export default {
    // all page
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    save: 'บันทึก',
    close: 'ปิด',
    edit: "แก้ไข",
    dataIterator: {
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        loadingText: 'Loading items...',
    },
    defaultLayout: {
        note: "หมายเหตุ",
        logout: 'ออกจากระบบ',
        change_pwd: 'เปลี่ยนรหัสผ่าน',
        sidebar: {
            home: 'แดชบอร์ด',
            stores: 'ร้านค้า',
            admin: 'ผู้ดูแลระบบ',
            employee: 'พนักงาน',

            accountManagement: 'จัดการผู้ใช้',
            user: 'ผู้เรียน',
            account: 'ครู',
            instructor: 'ครู',
            instructorRegistration: 'การสมัครเป็นครู',

            courseManagement: 'จัดการคอร์สเรียน',
            myCourse: 'คอร์สของฉัน',
            relatedCourse: 'คอร์สที่ได้รับมอบหมาย',
            reportCourse: 'สรุปรายงานคอร์ส',

            usergroup: 'จัดการกลุ่มผู้ใช้',

            banner: 'จัดการป้ายโฆษณา',

            categoryManagement: 'จัดการหมวดหมู่',
            skill: 'ทักษะ',
            category: 'หมวดหมู่',
            level: 'ระดับ',
            companyManagement: 'จัดการองค์กร',

            report: 'รายงาน',
            dashboard: 'แดชบอร์ด',
            confirmTutor: 'ยืนยันตัวตนครูผู้สอน',

            withdraw: "การถอนเงิน",
            specialEvent: "กิจกรรม",
        },
        add: "เพิ่ม",
        search: "ค้นหา",
        list: "รายการ",
        edit: "แก้ไข",
        delete: "ลบ",
        dismiss: "ปิด",
        cancel: "ยกเลิก",
        save: "บันทึก",
        ok: "ตกลง",
        reset: "คืนค่าเริ่มต้น",
        upload: "อัพโหลด",
        dialog: {
            uploadImg: "อัพโหลดรูปภาพ",
            fileOver: "ขนาดไฟล์เกิน 1MB",
            uploadedText: "อัพโหลดแล้ว",
            successful: "สำเร็จ",
        },
        profile: "ข้อมูลส่วนตัว",
        editProfile: "แก้ไขโปรไฟล์",
        uploadPhoto: "อัปโหลดรูปภาพ",
        choosePhoto: "เลือกรูปภาพ",
        chooseNewPhoto: "เลือกรูปภาพใหม่",
        gender: "เพศ",
        firstName: "ชื่อจริง",
        lastName: "นามสกุล",
        email: "อีเมล",
        username: "ชื่อผู้ใช้",
        organization: "องค์กร",
        changePass: "เปลี่ยนรหัสผ่าน",
        oldPass: "รหัสผ่านเก่า",
        newPass: "รหัสผ่านใหม่",
        confirmPass: "ยืนยันรหัสผ่าน",
        completed: "เสร็จสิ้น",
        least8characters: "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป",
        matchedPassword: "กรุณากรอกรหัสผ่านให้ตรงกัน",
        enterFirstname: "กรุณากรอกชื่อจริง",
        enterLastname: "กรุณากรอกนามสกุล",
        enterGender: "กรุณาเลือกเพศ",
        enterUsername: "กรุณากรอกชื่อผู้ใช้",
        enterEmail: "กรุณากรอกอีเมล",
        male: "ชาย",
        female: "หญิง",
        unknown: "ไม่ระบุ",
        editingUserSucceeded: "แก้ไขผู้ใช้งานสำเร็จ",
        userInformationUpdated: "เราได้บันทึกข้อมูลของคุณแล้ว",
        copy: "คัดลอก",
        copied: "คัดลอกแล้ว",

    },
    lang: {
        languages: 'ภาษาที่แสดง',
        english: 'อังกฤษ',
        thailand: 'ไทย',
    },

    learnerManagement: {
        learner: 'ผู้เรียน',
        importUsers: 'นำเข้าผู้ใช้งาน',
        exportUsers: 'ดาวน์โหลดรายชื่อ',
        addUser: 'เพิ่มผู้ใช้งาน',
        sorry: 'ขออภัย',
        msg1: 'คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ',
        msg2: 'กำหนดสิทธิ์',
        msg3: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',
        ok: 'ตกลง',
        userManageBtn: "จัดการผู้ใช้งาน",
        recycleBin: "ถังขยะ",
        sort: "เรียงตาม",
        sortBy: "เรียงโดย",
        filterBar: {
            search: 'ค้นหา',
            searchNameEmail: 'ค้นหา ชื่อ หรือ อีเมล',
            selectGroup: 'เลือกกลุ่ม',
            groupFilter: 'ตัวกรองกลุ่ม',
            status: 'สถานะ',
            reload: 'โหลดใหม่',
            all: 'ทั้งหมด',
            on: 'เปิด',
            off: 'ปิด',
        },
        learnerList: {
            photo: 'รูปภาพ',
            prefix: 'คำนำหน้า',
            name: 'ชื่อ',
            email: 'อีเมล',
            username: 'ชื่อผู้ใช้งาน',
            group: 'กลุ่ม',
            groups: 'กลุ่ม',
            clickToEditGroup: 'คลิกเพื่อแก้ไขกลุ่ม',
            clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
            clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',
            status: 'สถานะ',
            edit: 'แก้ไข',
            searchGroups: 'ค้นหากลุ่ม',
            selectedGroups: 'กลุ่มที่เลือก',
            cancel: 'ยกเลิก',
            save: 'บันทึก',
            confirm: 'ยืนยัน',
            confirmSuspend: 'คุณต้องการระงับผู้ใช้งานนี้หรือไม่',
            suspendDetail: 'เมื่อระงับการใช้งานแล้ว สามารถกลับมาเปิดการใช้งานได้ภายหลัง',
            confirmActivate: 'คุณต้องการเปิดผู้ใช้งานนี้หรือไม่',
            activateDetail: 'เป็นการเปลี่ยนสถานะผู้ใช้งานให้กลับมาใช้งานได้อีกครั้ง',
            addNewUser: 'เพิ่มผู้ใช้งาน',
            editUser: 'แก้ไขข้อมูลผู้ใช้งาน',
            information: 'ข้อมูลผู้ใช้งาน',
            accessRight: 'กำหนดสิทธิ์การเข้าถึง',
            profileImage: 'รูปโปรไฟล์',
            upload: 'อัปโหลด',
            acceptableFormats: 'ประเภทไฟล์ที่สามารถอัปโหลดได้',
            maxFileSize: 'ขนาดไฟล์สูงสุดไม่เกิน 1MB',
            accountInformation: 'ข้อมูลผู้ใช้งาน',
            prefixName: 'คำนำหน้า',
            firstName: 'ชื่อ',
            lastName: 'นามสกุล',
            prefixNameEng: 'คำนำหน้าภาษาอังกฤษ',
            firstNameEng: 'ชื่อภาษาอังกฤษ',
            lastNameEng: 'นามสกุลภาษาอังกฤษ',
            gender: 'เพศ',
            male: 'ชาย',
            female: 'หญิง',
            notSpecified: 'ไม่ระบุ',

            groupRules: 'กรุณาระบุกลุ่ม',
            nameRules: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            genderRules: 'กรุณาระบุเพศ',
            prefixRules: 'กรุณากรอกคำนำหน้าชื่อ',
            firstNameRules: 'กรุณากรอกชื่อจริง',
            lastNameRules: 'กรุณากรอกนามสกุล',
            prefixEngRules: 'กรุณากรอกคำนำหน้าชื่อภาษาอังกฤษ',
            firstNameEngRules: 'กรุณากรอกชื่อจริงภาษาอังกฤษ',
            lastNameEngRules: 'กรุณากรอกนามสกุลภาษาอังกฤษ',
            userNameRules: 'กรุณากรอกชื่อผู้ใช้งาน',
            emailRule1: 'กรุณากรอกอีเมล',
            emailRule2: 'กรุณากรอกให้อยู่ในรูปแบบอีเมล',
            passwordRules: 'กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป',
            confirmPasswordRules: 'กรุณากรอกรหัสผ่านให้ตรงกัน',

            successfullySave: 'บันทึกเรียบร้อย',
            canModifyLater: 'สามารถเปิด/ปิดการใช้งานได้ภายหลัง',
            done: 'เสร็จสิ้น',

            organization: 'องค์กร',
            usernameSm: 'ชื่อผู้ใข้งาน',
            emailSm: 'อีเมล',
            groupSm: 'กลุ่ม',
            groupsSm: 'กลุ่ม',
            selectGroup: 'เลือกกลุ่ม',
            updatePassword: 'แก้ไขรหัสผ่าน',
            password: 'รหัสผ่าน',
            passwordSm: 'รหัสผ่าน',
            confirmPassword: 'ยืนยันรหัสผ่าน',

            systemManagement: 'จัดการระบบ',
            assignAdmin: 'กำหนดให้เป็นแอดมิน',
            manageUsers: 'จัดการผู้ใช้งาน',
            accessUserData: 'เข้าถึงข้อมูลผู้ใช้งาน',
            editUserData: 'แก้ไขข้อมูลผู้ใช้งาน',
            createNewUser: 'เพิ่มรายชื่อผู้ใช้งาน',
            suspendUserAccount: 'ระงับผู้ใช้งาน',

            manageGroups: 'จัดการกลุ่มผู้ใช้งาน',
            accessAndEditGroups: 'เข้าถึง/แก้ไข กลุ่มผู้ใช้งาน',

            manageCourses: 'จัดการคอร์สเรียน',
            assignInstructor: 'กำหนดให้เป็นครู',
            accessCourses: 'เข้าถึงรายการคอร์ส',
            editCourses: 'แก้ไขคอร์สเรียน',
            createNewCourses: 'สร้างคอร์สเรียน',
            suspendCourses: 'ระงับคอร์สเรียน',

            dataManagement: 'จัดการข้อมูล',
            accessEditDelete: 'เข้าถึง/เพิ่ม/แก้ไข/ลบ หมวดหมู่/ทักษะ/ชั้นเรียน',

            bannerManagement: 'จัดการโฆษณา',
            accessEditDeleteBanner: 'เข้าถึง/เพิ่ม/แก้ไข/ลบ โฆษณา',

            dashboardReport: 'แดชบอร์ด และ รายงาน',
            accessDashboardReport: 'เข้าถึง แดชบอร์ด และ รายงาน',

            successfullyEditingGroups: 'จัดกลุ่มผู้ใช้งานสำเร็จ',
            groupsSaved: 'เราได้บันทึกข้อมูลของคุณแล้ว',

            headerTableGroup: {
                group: "กลุ่ม",
                ID: "ไอดี",
            },
            viewActivity: 'ดูกิจกรรม',
        },
        importUsersDialog: {
            importUsers: 'นำเข้าข้อมูลผู้เรียน',
            createMyOwnPassword: 'สร้างรหัสผ่านด้วยตัวเอง',
            generatePassword: 'ให้ระบบสร้างรหัสผ่าน',
            downloadSample: 'ดาวน์โหลดไฟล์ตัวอย่าง',
            dragFile: 'ลากไฟล์ที่ต้องการนำเข้าหรือคลิกที่นี่เพื่อเลือกไฟล์',
            downloadInstruction: 'การดาวน์โหลดไฟล์ตัวอย่าง',
            downloadInstructionDetail: 'การนำเข้าทั้งแบบสร้างรหัสผ่านด้วยตัวเอง หรือแบบให้ระบบสร้างรหัสผ่านให้ มีความแตกต่างกันคือ แบบสร้างรหัสผ่านด้วยตัวเองจะมีส่วนของการระบุรหัสผ่านในไฟล์ตัวอย่าง ดังนั้นผู้ใช้ควรนำเข้าข้อมูลให้ถูกต้องตามรูปแบบไฟล์ตัวอย่างของระบบ',
            importedFileData: 'ตัวอย่างข้อมูลนำเข้า',
            group: 'กลุ่ม',
            chooseGroup: 'เลือกกลุ่มที่ต้องการค้นหา',
            cancel: 'ยกเลิก',
            confirmImporting: 'ยืนยันการนำเข้าข้อมูล',
            confirmEditing: 'ยืนยันการแก้ไขข้อมูล',
            pleaseWait: 'กรุณารอสักครู่...',
            validToImport: 'สามารถนำเข้าได้',
            alreadyExisted: 'มีอยู่ในระบบแล้ว',

            username: 'ชื่อผู้ใช้',
            prefix: 'คำนำหน้า',
            firstName: 'ชื่อจริง',
            lastName: 'นามสกุล',
            gender: 'เพศ',
            email: 'อีเมล',
            password: 'รหัสผ่าน',

            successfullyAdded: 'เพิ่มผู้ใช้งานสำเร็จ',
            addingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',
            done: 'เสร็จสิ้น',

            failedToAdd: 'เพิ่มผู้ใช้งานไม่สำเร็จ',
            errorOccured: 'เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง',
            ok: 'ตกลง',

            successfullyEdited: 'แก้ไขผู้ใช้งานสำเร็จ',
            editingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

            failedToModify: 'แก้ไขผู้ใช้งานไม่สำเร็จ',
            errorEditOccured: 'เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง',

            failedToSave: 'บันทึกไม่สำเร็จ',
            errorDuplicate: 'อีเมล หรือชื่อผู้ใช้นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น',

            failedToUpload: 'ไม่สามารถอัพโหลดไฟล์นี้ได้',
            duplicatedEmail: 'อีเมลซ้ำ',
            or: 'หรือ',
            failedHeader: 'ชื่อหัวฟิลด์ไม่สามารถใช้ได้ (สามารถใช้ a-z, A-Z)',
            errorDuplicatedEmail: 'คุณไม่สามารถอัพโหลดไฟล์นี้ได้ กรุณาตรวจสอบข้อมูลอีกครั้ง',
            close: 'ปิด',
        },
    },

    instructorManagement: {
        instructor: 'ครู',
        sorry: 'ขออภัย',
        msg1: 'คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ',
        msg2: 'กำหนดสิทธิ์',
        msg3: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',
        ok: 'ตกลง',
        filterBar: {
            search: 'ค้นหา',
            cancelSearch: 'ยกเลิกการค้นหา',
            searchNameEmail: 'ค้นหา ชื่อ หรือ อีเมล',
            status: 'สถานะ',
            reload: 'โหลดใหม่',
            all: 'ทั้งหมด',
            on: 'เปิด',
            off: 'ปิด',
            result: 'คลิกเพื่อเลือกจากผลการค้นหา'
        },
        instructorList: {
            photo: 'รูปภาพ',
            prefix: 'คำนำหน้า',
            name: 'ชื่อ',
            email: 'อีเมล',
            username: 'ชื่อผู้ใช้งาน',
            group: 'กลุ่ม',

            groups: 'กลุ่ม',
            clickToEditGroup: 'คลิกเพื่อแก้ไขกลุ่ม',
            clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
            clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',

            status: 'สถานะ',
            searchGroups: 'ค้นหากลุ่ม',
            selectedGroups: 'กลุ่มที่เลือก',
            cancel: 'ยกเลิก',
            save: 'บันทึก',
            confirm: 'ยืนยัน',
            confirmSuspend: 'คุณต้องการระงับผู้ใช้งานนี้หรือไม่',
            suspendDetail: 'เมื่อระงับการใช้งานแล้ว สามารถกลับมาเปิดการใช้งานได้ภายหลัง',
            confirmActivate: 'คุณต้องการเปิดผู้ใช้งานนี้หรือไม่',
            activateDetail: 'เป็นการเปลี่ยนสถานะผู้ใช้งานให้กลับมาใช้งานได้อีกครั้ง',

            successfullySave: 'บันทึกเรียบร้อย',
            canModifyLater: 'สามารถเปิด/ปิดการใช้งานได้ภายหลัง',
            done: 'เสร็จสิ้น',

            successfullyEditingGroups: 'จัดกลุ่มผู้ใช้งานสำเร็จ',
            groupsSaved: 'เราได้บันทึกข้อมูลของคุณแล้ว',

            edit: 'แก้ไข',
            editUser: 'แก้ไขข้อมูลผู้ใช้งาน',
            information: 'ข้อมูลผู้ใช้งาน',
            accessRight: 'กำหนดสิทธิ์การเข้าถึง',
            profileImage: 'รูปโปรไฟล์',
            upload: 'อัปโหลด',
            acceptableFormats: 'ประเภทไฟล์ที่สามารถอัปโหลดได้',
            maxFileSize: 'ขนาดไฟล์สูงสุดไม่เกิน 1MB',
            accountInformation: 'ข้อมูลผู้ใช้งาน',
            prefixName: 'คำนำหน้า',
            firstName: 'ชื่อ',
            lastName: 'นามสกุล',
            gender: 'เพศ',
            male: 'ชาย',
            female: 'หญิง',
            notSpecified: 'ไม่ระบุ',

            groupRules: 'กรุณาระบุกลุ่ม',
            nameRules: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            genderRules: 'กรุณาระบุเพศ',
            prefixRules: 'กรุณากรอกคำนำหน้าชื่อ',
            firstNameRules: 'กรุณากรอกชื่อจริง',
            lastNameRules: 'กรุณากรอกนามสกุล',
            userNameRules: 'กรุณากรอกชื่อผู้ใช้งาน',
            emailRule1: 'กรุณากรอกอีเมล',
            emailRule2: 'กรุณากรอกให้อยู่ในรูปแบบอีเมล',
            passwordRules: 'กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป',
            confirmPasswordRules: 'กรุณากรอกรหัสผ่านให้ตรงกัน',
            descriptionRules: 'กรุณาระบุเหตุผล หรือ หมายเหตุ',

            organization: 'องค์กร',
            usernameSm: 'ชื่อผู้ใข้งาน',
            emailSm: 'อีเมล',
            groupSm: 'กลุ่ม',
            groupsSm: 'กลุ่ม',
            selectGroup: 'เลือกกลุ่ม',
            updatePassword: 'แก้ไขรหัสผ่าน',
            password: 'รหัสผ่าน',
            passwordSm: 'รหัสผ่าน',
            confirmPassword: 'ยืนยันรหัสผ่าน',

            systemManagement: 'จัดการระบบ',
            assignAdmin: 'กำหนดให้เป็นแอดมิน',
            manageUsers: 'จัดการผู้ใช้งาน',
            accessUserData: 'เข้าถึงข้อมูลผู้ใช้งาน',
            editUserData: 'แก้ไขข้อมูลผู้ใช้งาน',
            createNewUser: 'เพิ่มรายชื่อผู้ใช้งาน',
            suspendUserAccount: 'ระงับผู้ใช้งาน',


            accessAndEditGroups: 'เข้าถึง/แก้ไข กลุ่มผู้ใช้งาน',

            manageCourses: 'จัดการคอร์สเรียน',
            assignInstructor: 'กำหนดให้เป็นครู',
            accessCourses: 'เข้าถึงรายการคอร์ส',
            editCourses: 'แก้ไขคอร์สเรียน',
            createNewCourses: 'สร้างคอร์สเรียน',
            suspendCourses: 'ระงับคอร์สเรียน',

            manageGroups: 'จัดการกลุ่มผู้ใช้งาน',
            accessEditDelete: 'เข้าถึง/แก้ไข/ลบ กลุ่มผู้ใช้งาน',

            dashboardReport: 'แดชบอร์ด และ รายงาน',
            accessDashboardReport: 'เข้าถึง แดชบอร์ด และ รายงาน',

            description: 'รายละเอียด',
            desc: 'พิมพ์รายละเอียดที่นี่...',
        },
        importUsersDialog: {
            successfullyAdded: 'ยืนยันคำอนุมัติสำเร็จ',
            addingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',
            done: 'เสร็จสิ้น',

            failedToAdd: 'ยืนยันคำอนุมัติไม่สำเร็จ',
            errorOccured: 'เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง',
            ok: 'ตกลง',

            successfullyEdited: 'แก้ไขผู้ใช้งานสำเร็จ',
            editingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

            failedToModify: 'แก้ไขผู้ใช้งานไม่สำเร็จ',
            errorEditOccured: 'เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง',

            failedToSave: 'บันทึกไม่สำเร็จ',
            errorDuplicate: 'อีเมล หรือชื่อผู้ใช้นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น',
        },
    },

    // CoursecourseManagement
    courseManagement: {
        // title: '',
        myCourse: 'คอร์สของฉัน',
        newCourse: 'เพิ่มคอร์ส',
        courseName: 'ชื่อคอร์สเรียน',
        teacherName: 'ชื่อครู',
        search: 'ค้นหา',
        searchBy: 'ค้นหาโดย',
        sort: "เรียงลำดับตาม",
        courseCannotPublished: "ไม่สามารถเผยแพร่คอร์สเรียนได้เนื่องจาก",
        filterBar: {
            filter: 'ตัวกรอง',
            search: 'ค้นหา',
            refresh: 'โหลดใหม่',
            bin: 'ถังขยะ',
            addCourse: 'เพิ่มคอร์ส',
            lowToHighTime: 'วันที่ ต่ำ-สูง',
            highToLowTime: 'วันที่ สูง-ต่ำ',
            lowToHighRating: 'ยอดนิยม ต่ำ-สูง',
            highToLowRating: 'ยอดนิยม สูง-ต่ำ',
            categories: 'หมวดหมู่',
            skills: 'ทักษะ',
            status: 'สถานะ',
            all: 'ทั้งหมด',
            on: 'เปิด',
            off: 'ปิด',
            selectedSkills: 'ทักษะที่เลือก',
            publish: 'เปิดการใช้งาน',
            disable: 'ปิดการใช้งาน',
            plsChooseSkill: "กรุณาเลือกทักษะ",
            plsChooseCategories: "กรุณาเลือกหมวดหมู่",
            addLive: 'เพิ่มการถ่ายทอดสด',
            addBundle: 'เพิ่มการซื้อขาย'
        },
        lectureStep: {
            sectionOrLecture: "บทเรียน/เนื้อหา",
            lecture: "มีเนื้อหา",
            questions: "คำถาม",
            noQuestion: "การเปิดการใช้งาน, ต้องมีมากกว่า 1 คำถาม",
            dragToMoveSequence: "ลากเพื่อย้ายลำดับ",
            clickToHideOrShow: "กดเพื่อซ่อน หรือแสดง",
            addSection: "เพิ่มบทเรียน",
            sectionName: "ชื่อบทเรียน",
            addTutor: "ผู้สอนสำหรับบทเรียนนี้",
            editOrAddSection: "แก้ไข/เพิ่ม บทเรียน",
            edit: "แก้ไข",
            EnableSuspend: "เปิด/ระงับ การใช้งาน",
            alertSetTimeExam: "หากคุณต้องการระบุช่วงเวลาของการเปิดการใช้งาน กรุณากดปุ่มแก้ไข",
            alertEnable: 'คุณต้องการ "เปิดการใช้งาน" ใช่หรือไม่',
            alertSuspend: 'คุณต้องการ "ระงับการใช้งาน" ใช่หรือไม่',
            tooltripClose: "ปิดหน้าต่าง",
            alertDeleteLesson: "คุณต้องการลบบทเรียนนี้หรือไม่",
            alertDeleteLessonCantBringData: "เมื่อลบบทเรียนนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
            alertSuccessfullyDeleteLesson: "ลบบทเรียนเรียบร้อย",
            alertLessonDeletedFromSystem: "บทเรียนถูกลบออกจากระบบเรียบร้อยแล้ว",
            alertNotSavedChange: "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง",
            alertNotSavedCreationOrEditing: "คุณยังไม่ได้บันทึกการสร้าง / แก้ไขบทเรียน ต้องการบันทึกหรือไม่",
            alertLeavePageTitle: "ต้องการออกจากหน้านี้ใช่ไหม",
            alertLeavePageSubTitle: "คุณยังไม่ได้บันทึกบทเรียน คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึก",
            removeSection: "ลบบทเรียน",
            publish: 'เปิดการใช้งาน',
            disable: 'ปิดการใช้งาน',
            delete: "ลบ",
            cancel: "ยกเลิก",
            confirm: 'ยืนยัน',
            plsEnterSectionName: "กรุณากรอกชื่อบทเรียน",
            save: "บันทึก",
            ok: "ตกลง",
            done: "เสร็จสิ้น",
            back: "ย้อนกลับ",
            exit: "ออกจากหน้านี้",
            next: "ถัดไป",

            //insertLecture
            video: "วิดีโอ",
            document: "เอกสาร",
            photo: "รูปภาพ",
            book: "หนังสือ",
            website: "เว็บไซต์",
            otherFiles: "ไฟล์อื่นๆ",
            article: "บทความ",
            examination: "ข้อสอบ",
            addLecture: "เพิ่มเนื้อหา",
            youtube: "ยูทูบ (Youtube)",

            //insertVideo
            insertVideo: {
                addEditVideo: "เพิ่ม/แก้ไข วิดีโอ",
                close: "ปิดหน้าต่าง",
                videoName: "ชื่อวิดีโอ",
                pleaseFillName: "กรุณากรอกชื่อวิดีโอ",
                videoattachment: "ไฟล์วิดีโอ",
                mp4: "MP4",
                details: "รายละเอียด",
                pleaseFillDetails: "กรุณากรอกรายละเอียด",
                chooseFile: "กรุณาเลือกไฟล์วิดีโอที่ต้องการ",
                errorUploadAgain: "ไม่สามารถดูวิดิโอได้ กรุณาอัพโหลดใหม่",
                notSaved: "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง",
                doYouWantToSave: "คุณยังไม่ได้บันทึกการเพิ่ม / แก้ไขวิดีโอ ต้องการบันทึกหรือไม่",
                maxFileSize5GB: "กรุณาเลือกไฟล์วิดีโอที่มีขนาดไม่เกิน 5 GB",
                maxFileSize1GB: "กรุณาเลือกไฟล์วิดีโอที่มีขนาดไม่เกิน 1 GB",
                cancel: "ยกเลิก",
                save: "บันทึก",
            },

            insertDocument: {
                addEditDoc: "แก้ไข/เพิ่ม เอกสาร",
                close: "ปิดหน้าต่าง",
                docName: "ชื่อเอกสาร",
                pleaseFillName: "กรุณากรอกชื่อเอกสาร",
                detail: "รายละเอียด",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                chooseFile: "กรุณาเลือกไฟล์เอกสารที่ต้องการ",
                docFile: "ไฟล์เอกสาร",
                docFileInstruction: "ไฟล์ประเภทนามสกุล PDF เท่านั้น",
                files: "ไฟล์",
                sample: "ตัวอย่างเอกสาร",
                perMissionDownload: "การอนุญาตให้ดาวน์โหลดไฟล์",
                noDownload: "ไม่อนุญาตให้ดาวน์โหลด",
                canDownload: "อนุญาตให้ดาวน์โหลด",
            },

            insertPhoto: {
                addEditPhoto: "แก้ไข/เพิ่ม รูปภาพ",
                close: "ปิดหน้าต่าง",
                photoName: "ชื่อรูปภาพ",
                pleaseFillName: "กรุณากรอกชื่อรูปภาพ",
                detail: "รายละเอียด",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                chooseFile: "กรุณาเลือกไฟล์รูปภาพที่ต้องการ",
                photoFile: "ไฟล์รูปภาพ",
                photoFileInstruction: "ไฟล์ประเภทนามสกุล JPG หรือ PNG",
                photoFilePlH: "อัปโหลดไฟล์รูปภาพที่ต้องการ (สูงสุด 20 รูป)",
                files: "ไฟล์",
                sample: "ตัวอย่างรูปภาพ",
                undo: "แก้ไขใหม่",
            },

            insertEbook: {
                addEditEbook: "แก้ไข/เพิ่ม หนังสือ",
                close: "ปิดหน้าต่าง",
                ebookName: "ชื่อหนังสือ",
                pleaseFillName: "กรุณากรอกชื่อหนังสือ",
                detail: "รายละเอียด",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                chooseFile: "กรุณาเลือกไฟล์หนังสือที่ต้องการ",
                ebookFile: "ไฟล์หนังสือ",
                ebookFileInstruction: "ไฟล์ประเภทนามสกุล PDF เท่านั้น",
                files: "ไฟล์",
                sample: "ตัวอย่างหนังสือ (E-Book)",
                undo: "แก้ไขใหม่",
                perMissionDownload: "การอนุญาตให้ดาวน์โหลดไฟล์",
                noDownload: "ไม่อนุญาตให้ดาวน์โหลด",
                canDownload: "อนุญาตให้ดาวน์โหลด",
            },

            insertURL: {
                addEditURL: "แก้ไข/เพิ่ม เว็บไซต์",
                close: "ปิดหน้าต่าง",
                urlName: "ชื่อ URL",
                pleaseFillName: "กรุณากรอกชื่อเว็บไซต์",
                detail: "รายละเอียด",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                url: "ลิงก์เว็บไซต์ (URL)",
                urlPlH: "กรุณากรอกลิงก์เว็บไซต์ (URL)",
                sample: "ตัวอย่าง URL",
            },

            insertOther: {
                addEditOther: "แก้ไข/เพิ่ม ไฟล์อื่นๆ",
                close: "ปิดหน้าต่าง",
                otherName: "ชื่อไฟล์",
                pleaseFillName: "กรุณากรอกชื่อไฟล์",
                detail: "รายละเอียด",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                chooseFile: "กรุณาเลือกไฟล์ที่ต้องการ",
                otherFile: "ไฟล์อื่นๆ",
                files: "ไฟล์",
                sample: "ตัวอย่างไฟล์",
                undo: "แก้ไขใหม่",
                testDownload: "ทดสอบดาวน์โหลดไฟล์",
                remark: "คำแนะนำ",
                msg1: "ไฟล์ที่อัปโหลดไปยังระบบผู้เรียนจะสามารถดาวน์โหลดไฟล์ไปยังอุปกรณ์ของผู้เรียนได้ เช่น ไฟล์",
                msg2: "PowerPoint",
                msg3: "Word",
                msg4: " เป็นต้น โดยทั้งนี้การดาวน์โหลดไฟล์หรือการแสดงผลไฟล์จะขึ้นอยู่กับอุปกรณ์ของผู้เรียนเอง",
                timeLeft: "เหลือเวลาอีก ",
                day: " วัน ",
                hour: " ชั่วโมง ",
                minute: " นาที ",
                second: " วินาที ",

            },

            insertArticle: {
                addEditArticle: "แก้ไข/เพิ่ม บทความ",
                close: "ปิดหน้าต่าง",
                articleName: "ชื่อบทความ",
                pleaseFillName: "กรุณากรอกชื่อบทความ",
                detail: "รายละเอียด",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                article: "บทความ",
                articlePlH: "กรุณากรอกบทความ",
            },

            insertExam: {
                addEditExam: "แก้ไข/เพิ่ม ข้อสอบ",
                close: "ปิดหน้าต่าง",
                edit: "แก้ไข",
                examDetail: "รายละเอียดข้อสอบ",
                examQuestion: "คำถาม",
                examName: "ชื่อชุดข้อสอบ",
                pleaseFillName: "กรุณากรอกชื่อชุดข้อสอบ",
                detail: "รายละเอียดชุดข้อสอบ",
                pleaseFillDetail: "กรุณากรอกรายละเอียด",
                exam: "ชุดข้อสอบ",
                examPlH: "กรุณากรอกข้อสอบ",
                question: "คำถาม",
                instruction: "คำอธิบาย/คำชี้แจงก่อนสอบ",
                timerOption: "การจับเวลา",
                noTimer: "ไม่จับเวลา",
                useTimer: "จับเวลา",
                minute: "นาที",
                second: "วินาที",
                times: "ครั้ง",
                typeExam: "รูปแบบข้อสอบ",
                remarkTypeExam: "เมื่อเลือกรูปแบบข้อสอบแล้วจะไม่สามารถเปลี่ยนรูปแบบข้อสอบได้",
                typeExamGeneral: "ข้อสอบรูปแบบทั่วไป",
                typeExamCustomizable: "ข้อสอบรูปแบบตั้งเงื่อนไข",
                numExamTries: "การทำซ้ำ",
                sigleTime: "ทำได้ครั้งเดียว",
                multiTimes: "ทำได้แบบกำหนดครั้ง",
                unlimited: "ทำได้หลายครั้ง",
                questionSolving: "การเฉลย",
                afterExam: "หลังสอบเสร็จ",
                oneByOne: "เฉลยทีละข้อ",
                noAnswer: "ไม่มีการเฉลย",
                randomQuestions: "การสุ่มข้อสอบ",
                randomChoices: "การสุ่มตัวเลือก",
                setPercent: "กำหนดเปอร์เซ็นต์ความถูกต้องในการผ่านเกณฑ์",
                no: "ไม่กำหนดเปอร์เซ็นต์",
                yes: "กำหนดเปอร์เซ็นต์",
                percentText: "เปอร์เซ็นต์",
                random: "สุ่มข้อสอบ",
                noRandom: "ไม่สุ่มข้อสอบ",
                random2: "สุ่มตัวเลือก",
                noRandom2: "ไม่สุ่มตัวเลือก",
                conditionRandom: "เงื่อนไขการสุ่มข้อสอบ",
                conditionRandomFirst: "สุ่มเฉพาะครั้งแรก",
                conditionRandomAlways: "สุ่มทุกครั้ง",
                GroupAssignmentOfQuestions: "การกำหนดกลุ่มของคำถาม",
                noGroupAssignmentOfQuestions: "ไม่กำหนดกลุ่มคำถาม",
                yesGroupAssignmentOfQuestions: "กำหนดกลุ่มคำถาม",
                groupListQuestion: "รายการกลุ่มคำถาม",
                publishedTimeDate: "ช่วงเวลาการเผยแพร่ข้อสอบ (ไม่บังคับ)",
                noPublishedTimeDate: "ไม่กำหนดช่วงเวลา",
                setPublishedTimeDate: "กำหนดช่วงเวลาเผยแพร่ข้อสอบ",
                start: "เริ่ม",
                end: "สิ้นสุด",
                scheduleInstruction: "วันที่สิ้นสุดต้องมากกว่าวันที่เริ่มต้น",
                cancel: "ยกเลิก",
                save: "บันทึก",
                chooseRandom: "เลือกสุ่ม ",
                ofQuestion: " ข้อ",
                ofQuestionTotal: "จากทั้งหมด",
                perQuestion: "ข้อละ ",
                pointPerQuestion: " คะแนน",
                total: "รวม",
                totalScore: " คะแนน",
                nameGroup: "ชื่อกลุ่มคำถาม",
                numberOfQuestion: "จำนวนข้อ",
                addGroupQuestion: "พิมพ์เพื่อกำหนดกลุ่มคำถาม",
                addQuestionGroup: "เพิ่มกลุ่มคำถาม",
                totalScoreOfExam: "คะแนนรวมข้อสอบชุดนี้",

                instructionQuestion: "คำแนะนำ",
                msg1: "วิธีการเพิ่มข้อสอบ",
                msg2: "สามารถเพิ่มข้อสอบได้",
                msg3: "ครั้งละ 1 ข้อ",
                msg4: "โดยกดปุ่ม",
                msg5: "เพิ่มคำถาม",
                msg6: "",
                msg7: "วิธีการนำเข้าข้อสอบ",
                msg8: "สามารถเพิ่มข้อสอบประเภท",
                msg9: "ตัวเลือกเดียว",
                msg10: "หรือ",
                msg11: "หลายตัวเลือก",
                msg12: "ได้ครั้งละหลายข้อโดยการกดปุ่ม",
                msg13: "นำเข้าข้อสอบ",
                msg14: "",
                msg15: "หมายเหตุ",
                msg16: "การเพิ่มข้อสอบด้วยการนำเข้าจากไฟล์ Excel จะไม่สามารถเพิ่มสื่อต่าง ๆ ได้เช่น รูปภาพ เสียง และวิดีโอเป็นต้น",
                msg17: "หากต้องการเพิ่มสื่อต่าง ๆ ในข้อสอบสามารถกดปุ่ม",
                msg18: "แก้ไขข้อสอบ",
                msg19: "ได้ภายหลังจาการนำเข้าข้อสอบสำเร็จ",
                mssg20: "เมื่อเลือกข้อสอบรูปแบบตั้งเงื่อนไข",
                mssg21: "จะไม่สามารถใช้คุณสมบัติบางประการของการสร้างข้อสอบได้ ได้แก่ ข้อสอบประเภทจับคู่ บทความ และเกม",
                mssg22: "สร้างชุดข้อสอบ",

                importExam: "นำเข้าชุดข้อสอบ",
                singleChoice: "ตัวเลือกเดียว",
                multipleChoices: "หลายตัวเลือก",
                matching: "จับคู่",
                fillBlank: "เติมคำ",
                article: "บทความ",
                game: "เกม",

                newQuestion: "เพิ่มคำถาม",

                selectAll: "เลือกทั้งหมด",
                delete: "ลบ",
                selectToDelete: "เลือกข้อเพื่อลบ",

                noQuestion: "ยังไม่มีข้อมูล กรุณากดปุ่ม \"+ เพิ่มคำถาม\"",
                modifyExam: "แก้ไขลำดับข้อสอบ",

                saveDone: "บันทึกข้อสอบเรียบร้อย",
                done: "เสร็จสิ้น",

                saveFailed: "บันทึกข้อสอบไม่สำเร็จ",
                saveFailedDetail: "กรุณาตรวจสอบความถูกต้อง",
                ok: "ตกลง",

                failedMsg1: "กรุณาตรวจสอบความถูกต้องของการจับเวลา",
                failedMsg2: "กรุณาตรวจสอบความถูกต้องของการทำซ้ำ",

                deleteQuestionConfirm: "คุณต้องการลบข้อสอบนี้หรือไม่",
                deleteQuestionConfirmDetail: "เมื่อลบข้อสอบนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
                confirm: "ยืนยัน",
                doingDelete: "กำลังลบ",

                deleteDone: "ลบข้อสอบเรียบร้อย",
                deleteDoneDetail: "ข้อสอบถูกลบออกจากระบบเรียบร้อยแล้ว",

                deleteMultiConfirm: "คุณต้องการลบข้อสอบที่เลือกหรือไม่",

                importSingleChoice: "นำเข้าข้อสอบตัวเลือกเดียว",
                msg20: "คำแนะนำ",
                msg21: "ข้อสอบตัวเลือกเดียว",
                msg22: "หมายถึงผู้ทำข้อสอบสามารถเลือกคำตอบที่ถูกต้องได้เพียง",
                msg23: "1 คำตอบเท่านั้น",
                mssg24: "ที่คอลัมน์ไอดี",
                mssg25: "สามารถนำไอดีของกลุ่มคำถามใส่ในช่อง question_group_id ในไฟล์ Excel",

                downloadSample: "ดาวน์โหลดไฟล์ตัวอย่าง",
                sampleImportData: "ตัวอย่างข้อมูลนำเข้า",
                confirmToImport: "ยืนยันการนำเข้าข้อสอบ",
                uploading: "กำลังนำเข้าข้อสอบ",

                importMultiChoice: "นำเข้าข้อสอบหลายตัวเลือก",
                msg24: "คำแนะนำ",
                msg25: "ข้อสอบหลายตัวเลือก",
                msg26: "หมายถึง ผู้ทำข้อสอบสามารถเลือกคำตอบที่ถูกต้องได้",
                msg27: "มากกว่า 1 คำตอบ",

                num: "ข้อที่",
                score: "คะแนน",
                questionQ: "โจทย์",
                correctAns: "คำตอบที่ถูกต้อง",
                ansDescription: "คำอธิบายเฉลย",
                choice: "ตัวเลือกที่",

                failedUpload: "อัปโหลดข้อสอบไม่สำเร็จ",
                failedUploadDetail: "ข้อสอบตัวเลือกเดียวสามารถมีคำตอบที่ถูกต้องได้เพียงข้อละ 1 คำตอบเท่านั้น",
                drag: "ลากเพื่อย้ายลำดับ",

                confirmDeleteQuestionGroup: "คุณต้องการลบกลุ่มคำถามนี้หรือไม่",
                confirmDeleteQuestionGroupDetail: "เมื่อลบกลุ่มคำถามนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
                deleteQuestionGroupDone: "ลบกลุ่มคำถามเรียบร้อย",
                deleteQuestionGroupDoneDetail: "กลุ่มคำถามถูกลบออกจากระบบเรียบร้อยแล้ว",
                savingFailed: "บันทึกไม่สำเร็จ",
                questionGroupDuplicate: "ชื่อกลุ่มคำถามนี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น",

                saveFailMsg: "มีบางอย่างผิดปกติ กรุณาลองใหม่อีกครั้ง",

                tableHeaderLevel: {
                    questionGroupName: "ชื่อกลุ่มคำถาม",
                    countRandom: "จำนวนที่เลือกสุ่ม",
                    score: "คะแนน",
                    ID: "ไอดี",
                },

                tableHeaderNormal: {
                    no: "ข้อที่",
                    score: "คะแนน",
                    question: "โจทย์",
                    correctAns: "คำตอบที่ถูกต้อง",
                    ansDescription: "คำอธิบายเฉลย",
                    choice1: "ตัวเลือกที่ 1",
                    choice2: "ตัวเลือกที่ 2",
                    choice3: "ตัวเลือกที่ 3",
                    choice4: "ตัวเลือกที่ 4",
                    choice5: "ตัวเลือกที่ 5",
                    choice6: "ตัวเลือกที่ 6",
                    choice7: "ตัวเลือกที่ 7",
                    choice8: "ตัวเลือกที่ 8",
                    choice9: "ตัวเลือกที่ 9",
                    choice10: "ตัวเลือกที่ 10",
                },

                tableHeaderRandom: {
                    no: "ข้อที่",
                    questionGroup: "กลุ่มคำถาม",
                    score: "คะแนน",
                    question: "โจทย์",
                    correctAns: "คำตอบที่ถูกต้อง",
                    ansDescription: "คำอธิบายเฉลย",
                    choice1: "ตัวเลือกที่ 1",
                    choice2: "ตัวเลือกที่ 2",
                    choice3: "ตัวเลือกที่ 3",
                    choice4: "ตัวเลือกที่ 4",
                    choice5: "ตัวเลือกที่ 5",
                    choice6: "ตัวเลือกที่ 6",
                    choice7: "ตัวเลือกที่ 7",
                    choice8: "ตัวเลือกที่ 8",
                    choice9: "ตัวเลือกที่ 9",
                    choice10: "ตัวเลือกที่ 10",
                },

                insertSingle: {
                    addSingle: "เพิ่ม/แก้ไขข้อสอบ (ตัวเลือกเดียว)",
                    chooseQuestionGroup: "เลือกกลุ่มคำถาม",
                    question: "โจทย์",
                    addVoiceOpt: "เสียงประกอบโจทย์ (ไม่บังคับ)",
                    addVoice: "เพิ่มเสียง",
                    addVdoOpt: "วิดีโอประกอบโจทย์ (ไม่บังคับ)",
                    addVdo: "เพิ่มวิดีโอ",
                    score: "คะแนน",
                    randomType: "รูปแบบการสุ่มตัวเลือก",
                    noRandom: "ไม่สุ่มตัวเลือก",
                    random: "สุ่มตัวเลือก",
                    msg1: "คำแนะนำ",
                    msg2: "วิธีเลือกคำตอบที่ถูกคือคลิกที่ช่องวงกลมด้านซ้ายของคำตอบ",
                    answer: "เฉลย",
                    choices: "คำตอบ",
                    choice: "ตัวเลือก",
                    addChoice: "เพิ่มตัวเลือก",
                    answerDescription: "คำอธิบายเฉลย",
                    confirmDeleteChoice: "คุณต้องการลบตัวเลือกนี้หรือไม่",
                    confirmDeleteChoiceDetail: "เมื่อลบตัวเลือกนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
                    saveDone: "บันทึกเรียบร้อย",
                    saveDoneDetail: "สามารถแก้ไขข้อมูลได้ภายหลัง",
                    questionRules: "กรุณากรอกโจทย์",
                    answerDescriptionRules: "กรุณากรอกคำอธิบายเฉลย",
                    scoreRules: "กรุณากรอกคะแนน",
                },

                insertMultiple: {
                    addMultiple: "เพิ่ม/แก้ไขข้อสอบ (หลายตัวเลือก)",
                    chooseQuestionGroup: "เลือกกลุ่มคำถาม",
                    question: "โจทย์",
                    addVoiceOpt: "เสียงประกอบโจทย์ (ไม่บังคับ)",
                    addVoice: "เพิ่มเสียง",
                    addVdoOpt: "วิดีโอประกอบโจทย์ (ไม่บังคับ)",
                    addVdo: "เพิ่มวิดีโอ",
                    score: "คะแนน",
                    randomType: "รูปแบบการสุ่มตัวเลือก",
                    noRandom: "ไม่สุ่มตัวเลือก",
                    random: "สุ่มตัวเลือก",
                    msg1: "คำแนะนำ",
                    msg2: "วิธีเลือกคำตอบที่ถูกคือคลิกที่ช่องวงกลมด้านซ้ายของคำตอบ",
                    answer: "เฉลย",
                    choices: "คำตอบ",
                    choice: "ตัวเลือก",
                    addChoice: "เพิ่มตัวเลือก",
                    answerDescription: "คำอธิบายเฉลย",
                    confirmDeleteChoice: "คุณต้องการลบตัวเลือกนี้หรือไม่",
                    confirmDeleteChoiceDetail: "เมื่อลบตัวเลือกนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
                    saveDone: "บันทึกเรียบร้อย",
                    saveDoneDetail: "สามารถแก้ไขข้อมูลได้ภายหลัง",
                    questionRules: "กรุณากรอกโจทย์",
                    answerDescriptionRules: "กรุณากรอกคำอธิบายเฉลย",
                    scoreRules1: "กรุณากรอกคะแนน",
                    scoreRules2: "คะแนนต้องมากกว่า 0",
                },

                insertFillTheBlank: {
                    addFillTheBlank: "เพิ่ม/แก้ไขข้อสอบ (เติมคำ)",
                    chooseQuestionGroup: "เลือกกลุ่มคำถาม",
                    question: "โจทย์",
                    addVoiceOpt: "เสียงประกอบโจทย์ (ไม่บังคับ)",
                    addVoice: "เพิ่มเสียง",
                    addVdoOpt: "วิดีโอประกอบโจทย์ (ไม่บังคับ)",
                    addVdo: "เพิ่มวิดีโอ",
                    percent: "เปอร์เซ็นต์ความถูกต้องที่คาดหวัง",
                    score: "คะแนน",
                    randomType: "รูปแบบการสุ่มตัวเลือก",
                    noRandom: "ไม่สุ่มตัวเลือก",
                    random: "สุ่มตัวเลือก",
                    msg1: "คำแนะนำ",
                    msg2: "การระบุคะแนน",
                    msg3: "คือ การกำหนดคะแนนเต็มของข้อนี้",
                    msg4: "การกำหนดเปอร์เซ็นต์ความถูกต้องที่คาดหวัง",
                    msg5: "คือ การตรวจสอบประโยคของชุดคำตอบที่กำหนด และคำตอบของผู้ทำข้อสอบเมื่อระบบตรวจสอบรูปประโยคมีความตรงกันตามเปอร์เซ็นต์ความถูกต้องที่กำหนด ผู้ทำข้อสอบจะได้คะแนนตามที่ระบุไว้ข้างต้น",
                    answer: "เฉลย",
                    packCoices: "ชุดคำตอบที่ใช้ตรวจสอบ",
                    choice: "คำตอบที่ใช้ตรวจสอบความถูกต้อง",
                    choices: "คำตอบที่ ",
                    addChoice: "เพิ่มชุดคำตอบ",
                    answerDescription: "คำอธิบายเฉลย",
                    confirmDeleteChoice: "คุณต้องการลบตัวเลือกนี้หรือไม่",
                    confirmDeleteChoiceDetail: "เมื่อลบตัวเลือกนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
                    saveDone: "บันทึกเรียบร้อย",
                    saveDoneDetail: "สามารถแก้ไขข้อมูลได้ภายหลัง",
                    questionRules: "กรุณากรอกโจทย์",
                    answerDescriptionRules: "กรุณากรอกคำอธิบายเฉลย",
                    scoreRules1: "กรุณากรอกคะแนน",
                    scoreRules2: "คะแนนต้องมากกว่า 0",
                    percentRules1: "กรุณากรอกเปอร์เซ็นต์ความถูกต้อง",
                    percentRules2: "เปอร์เซ็นต์ความถูกต้องมีค่าระหว่าง 0-100",
                    answerRules: "กรุณากรอกคำตอบที่ใช้ตรวจสอบความถูกต้อง",

                },

                insertMatching: {
                    addMatching: "เพิ่ม/แก้ไขข้อสอบ (จับคู่)",
                    question: "โจทย์",
                    addVoiceOpt: "เสียงประกอบโจทย์ (ไม่บังคับ)",
                    addVoice: "เพิ่มเสียง",
                    addVdoOpt: "วิดีโอประกอบโจทย์ (ไม่บังคับ)",
                    addVdo: "เพิ่มวิดีโอ",
                    randomType: "รูปแบบการสุ่มตัวเลือก",
                    noRandom: "ไม่สุ่มตัวเลือก",
                    random: "สุ่มตัวเลือก",
                    score: "คะแนน",

                    ansOption: "ตัวเลือกคำตอบ",
                    msg1: "ขั้นตอนที่ 1",
                    msg2: "ใส่คำตอบ",
                    msg3: "ฝั่งตัวเลือกตั้งต้น",
                    msg4: "และ",
                    msg5: "ฝั่งตัวเลือก",
                    msg6: "ขั้นตอนที่ 2",
                    msg7: "กดปุ่ม",
                    msg8: "จับคู่ตัวเลือก",
                    msg9: "จากนั้นกดเลือกตัวเลือกที่ต้องการจับคู่ใน",
                    msg10: "ฝั่งตัวเลือก",
                    msg11: "เมื่อเลือกเสร็จแล้วให้กดปุ่ม",
                    msg12: "เสร็จสิ้น",
                    msg13: "(หากต้องการแก้ไขการจับคู่ให้กดปุ่ม",
                    msg14: "จับคู่ตัวเลือก",
                    msg15: "อีกครั้ง)",
                    msg16: "ขั้นตอนที่ 3",
                    msg17: "ระบุคะแนนที่",
                    msg18: "ฝั่งตัวเลือกตั้งต้น",
                    info1: "พิมพ์ตัวเลือกตั้งต้นในกล่องข้อความเพื่อเพิ่มตัวเลือกตั้งต้น",
                    info2: "พิมพ์ตัวเลือกในกล่องข้อความเพื่อเพิ่มตัวเลือก",
                    addChoiceASide: "เพิ่มตัวเลือกตั้งต้น",
                    addChoiceBSide: "เพิ่มตัวเลือก",
                    choiceASide: "ตัวเลือกตั้งต้นที่ ",
                    choiceBSide: "ตัวเลือก ",
                    scoreChoice: " คะแนน",
                    matchingWith: "จับคู่กับ",
                    choiceMatching: "ตัวเลือกที่ ",
                    info3: "กดเลือกจับคู่ที่ฝั่งตัวเลือก",
                    match: "จับคู่",
                    done: "เสร็จสิ้น",


                    answerDescription: "คำอธิบายเฉลย",
                    confirmDeleteChoice: "คุณต้องการลบตัวเลือกนี้หรือไม่",
                    confirmDeleteChoiceDetail: "เมื่อลบตัวเลือกนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก",
                    saveDone: "บันทึกเรียบร้อย",
                    saveDoneDetail: "สามารถแก้ไขข้อมูลได้ภายหลัง",
                    questionRules: "กรุณากรอกโจทย์",
                    answerDescriptionRules: "กรุณากรอกคำอธิบายเฉลย",
                    scoreRules1: "กรุณากรอกคะแนน",
                    scoreRules2: "คะแนนต้องมากกว่า 0",
                },

                insertArticle: {
                    addArticle: "เพิ่ม/แก้ไขข้อสอบ (บทความ)",
                    articleName: "ชื่อบทความ",
                    question: "บทความ",
                    saveDone: "บันทึกเรียบร้อย",
                    saveDoneDetail: "สามารถแก้ไขข้อมูลได้ภายหลัง",
                    articleRules: "กรุณากรอกบทความ",
                    scoreRules1: "กรุณากรอกคะแนน",

                },

                insertGame: {
                    addGame: "เพิ่ม/แก้ไขข้อสอบ (เกม)",
                    question: "โจทย์",
                    addVoiceOpt: "เสียงประกอบโจทย์ (ไม่บังคับ)",
                    addVoice: "เพิ่มเสียง",
                    addVdoOpt: "วิดีโอประกอบโจทย์ (ไม่บังคับ)",
                    addVdo: "เพิ่มวิดีโอ",
                    score: "คะแนน",
                    typeGame: "รูปแบบเกม",
                    MemoryGame: "เกมทดสอบความจำ",
                    CrosswordPuzzle: "เกมอักษรไขว้",
                    WordSearchPuzzle: "เกมค้นหาคำศัพท์",

                    randomType: "รูปแบบการสุ่มเกม",
                    noRandom: "ไม่สุ่มเกม",
                    random: "สุ่มเกม",
                    countRandom: "จำนวนการสุ่ม",
                    randomRules: "กรุณากรอกจำนวนการสุ่ม",
                    packGame: "คู่ที่ ",
                    msg1: "ใช้รูปภาพแรก",
                    addPhoto: "เพิ่มรูปภาพจับคู่",

                    sizeTables: "ขนาดตาราง n x n",
                    sizeTable: "ขนาดตาราง",
                    tableAnswer: "ตารางกำหนดคำตอบ",
                    listWord: "รายการคำ",
                    msg2: "กรุณาเพิ่มคำที่ต้องการลงในตาราง",
                    msg3: "ระบุคำในแต่ละช่อง",
                    scoreRules: "กรุณากรอกคะแนน",
                    questionRules: "กรุณากรอกโจทย์",


                },
            },


            //insertYoutube
            insertYoutube: {
                addEditYoutube: "เพิ่ม/แก้ไข ยูทูบ (Youtube)",
                close: "ปิดหน้าต่าง",
                videoName: "ชื่อวิดีโอ",
                pleaseFillName: "กรุณากรอกชื่อวิดีโอ",
                details: "รายละเอียด",
                pleaseFillDetails: "กรุณากรอกรายละเอียด",
                seeSample: "ดูตัวอย่าง",
                url: "ลิงก์ยูทูบ (Youtube url)",
                fillURL: "กรุณากรอกลิงก์ยูทูบ (Youtube url)",
                sample: "ตัวอย่างวิดีโอ",
                notSaved: "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง",
                doYouWantToSave: "คุณยังไม่ได้บันทึกการแก้ไข/เพิ่ม เอกสาร หากคุณต้องการ บันทึก กรุณากด บันทึก ที่หน้าแก้ไข หรือ กลับไปหน้าจัดการบทเรียนให้กด ยกเลิก",
                continue: "แก้ไขต่อ",
                ok: "ตกลง",
                isId: "คุณกรอกไอดียูทูบใช่หรือไม่?",
                errorFillAgain: "หากคุณดูตัวอย่างวิดีโอไม่ได้ กรุณากรอกในรูปแบบลิงค์/ไอดียูทูบใหม่อีกครั้ง",
                cancel: "ยกเลิก",
                save: "บันทึก",
            },
        },
        courseList: {
            courseImage: 'ปกคอร์ส',
            category: 'หมวดหมู่',
            prices: 'ราคา',
            status: 'สถานะ',
            viewReport: 'ดูรายงาน',
            addStudent: "เพิ่มผู้เรียน",
            edit: 'แก้ไข',
            manage: 'จัดการคอร์ส',
            manageLearner: 'จัดการ',
            clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
            clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',
            cancel: 'ยกเลิก',
            save: 'บันทึก',
            more: 'เพิ่มเติม',
            editCourse: 'แก้ไขคอร์ส',
            action: 'แก้ไขคอร์ส',
            free: 'ฟรี',
            baht: 'บาท',
            report: 'รายงาน',
            confirmDeleteItem: 'คุณยืนยันที่จะลบรายการนี้หรือไม่ ?',
            confirmUnpublish: 'คุณต้องการระงับการเผยแพร่คอร์สเรียนนี้หรือไม่ ?',
            unpublishDescript: 'เมื่อระงับการใช้งานแล้ว คุณสามารถกลับมาเผยแพร่ใหม่ได้ภายหลัง',
            confirmPublish: 'คุณต้องการเปิดการเผยแพร่คอร์สเรียนนี้หรือไม่?',
            publishDescript: 'เป็นการเปลี่ยนสถานะคอร์สเรียนให้กลับมาเผยแพร่อีกครั้ง',
            sorry: "ขออภัย",
            alertPermissionFunction: "คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ<strong>&nbsp;กำหนดสิทธิ์&nbsp;</strong>การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ",
            alertPermissionTeacher: "คุณไม่สามารถเข้าถึงรายการนี้ได้ เนื่องจากไม่มีการ<strong>&nbsp;กำหนดสิทธิ์&nbsp;</strong>การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ<strong>&nbsp;สมัครเป็นครู&nbsp;</strong> เพื่อเข้าถึงรายการนี้",
            alertRejectTeacher: "การ<strong>&nbsp;สมัครเป็นครู&nbsp;</strong>ของบัญชีนี้<strong class='red--text'>&nbsp;ไม่สำเร็จ&nbsp;</strong><br /><br /><strong style='text-decoration:underline'>เนื่องจาก</strong>",
            ok: "ตกลง",
            alertNotAbleToAccess: "คุณไม่สามารถเข้าถึงรายการนี้ได้ เนื่องจากการ<strong>&nbsp;สมัครเป็นครู&nbsp;</strong> ของบัญชีนี้ยังไม่ได้รับการยืนยัน กรุณารอ<strong>&nbsp;การยืนยัน&nbsp;</strong> จาก admin",
            chooseStudyingGroup: "เลือกกลุ่มเรียน",
            studentListInCourse: "รายชื่อผู้เรียนในคอร์ส",
            filter: "ตัวกรอง",
            clearFilter: "กลับไปค่าตั้งต้น",
            progress: "ความคืบหน้า",
            seeReport: "ดูรายงาน",
            accomplishment: "เรียนไปแล้วทั้งหมด (%)",
            video: "วีดีโอ (%)",
            pdf: "เอกสาร PDF (%)",
            exam: "ข้อสอบ (%)",
            studentInformation: "ข้อมูลผู้เรียน",
            progressReport: "รายงานความคืบหน้า",
            student: "ผู้เรียน",
            delete: "ลบ",
            editExpDate: 'แก้ไขวันหมดอายุ',

            // users
            studentManagement: 'จัดการผู้เรียน',

            successfullySave: 'บันทึกเรียบร้อย',
            canModifyLater: 'สามารถแก้ไขข้อมูลได้ภายหลัง',
            done: 'เสร็จสิ้น',

            failedToSave: 'ไม่สามารถเผยแพร่คอร์สเรียนได้เนื่องจาก',
        },
        detailStep: {
            instructionSkill: '<strong class="font-weight-bold">คำแนะนำ<label class="headExplan">"</label>ทักษะ<label class="headExplan">"</label></strong><br /> สารมารถสร้างชื่อทักษะใหม่ได้โดยการพิมพ์ชื่อทักษะที่ต้องการ และกดปุ่ม<label class="font-weight-bold">Enter</label> เพื่อให้ผู้เรียนสามารถค้นหาคอร์สเรียนของท่านได้จากชื่อทักษะนี้',
            instructionStudying: '<strong class="font-weight-bold">คำแนะนำ<label class="headExplan">"</label>วิธีการเรียน<label class="headExplan">"</label></strong><br />',
            instructionStudyingIndependent: '"เรียนแบบอิสระ" หมายถึง ผู้เรียนสามารถเรียนบทใดก็ได้',
            instructionStudyingSequently: '"เรียนตามลำดับบทเรียน" หมายถึง ผู้เรียนจะต้องเรียนตามลำดับบทเรียนที่ผู้สอนกำหนด',
            instructionBoard: '<strong class="font-weight-bold">คำแนะนำ<label class="headExplan">"</label>บอร์ดแลกเปลี่ยนความคิดเห็น <label class="headExplan">"</label></strong><br /> ผู้เรียนสามารถแลกเปลี่ยนความคิดเห็นระหว่างกันได้ผ่านแอปพลิเคชันบนโทรศัพท์มือถือ',
            instructionSendDM: '<strong class="font-weight-bold">คำแนะนำ<label class="headExplan">"</label>ส่งข้อความโดยตรงถึงผู้สอน <label class="headExplan">"</label></strong><br /> ผู้เรียนสามารถส่งข้อความถึงผู้สอนได้โดยตรง',
            instructionCourseCover: '<strong class="font-weight-bold">คำแนะนำ<label class="headExplan">"</label>ภาพของปกคอร์ส <label class="headExplan">"</label></strong><br /> การอัปโหลดรูปภาพปกคอร์ส ควรจะใช้รูปภาพที่มีอัตราส่วนภาพเป็น 4:3 เพื่อความสวยงามในการแสดงผลบนแอปพลิเคชัน',
            ok: "ตกลง",
        },
        accessStep: {
            search: 'ค้นหา',
            classroom: 'ห้องเรียน',
            started: 'เริ่มเรียน',
            notStarted: 'ยังไม่เริ่ม',
            reload: 'โหลดใหม่',
            progressReport: "รายงานความคืบหน้า",
            username: 'ชื่อผู้ใช้',
            email: 'อีเมล',
            phone: 'เบอร์โทร',
            birthdate: 'วัน/เดือน/ปี เกิด',
            gender: 'เพศ',
            course: 'คอร์ส',
            lesson: 'บทเรียน',
            lecture: 'บทที่',
            detail: 'รายละเอียด',

            pdf: 'เอกสาร',
            exam: 'ข้อสอบ',
            book: 'หนังสือ',
            vdo: 'วิดีโอ',
            youtube: 'ยูทูบ (Youtube)',
            blog: 'บทความ',
            img: 'รูปภาพ',
            file: 'ไฟล๋์',
            url: 'เว็บไซต์',

            completedLearner: 'นักเรียนที่สำเร็จ',

            reportExam: 'รายงานข้อสอบ',
            fullScore: 'คะแนนเต็ม',
            numOfQuestions: 'จำนวนคำถาม',

            num: 'ครั้งที่',
            examDate: 'วันสอบ',
            score: 'คะแนน',
            correct: 'ถูก',
            wrong: 'ผิด',
            noAnswer: 'ไม่ตอบ',
            action: 'แก้ไข',

            editScore: 'แก้ไขคะแนนการสอบ',
            question: 'คำถามที่',
            examType: 'ข้อสอบแบบ',
            notAnswer: 'ไม่ได้ตอบคำถาม',

            answer: 'คำตอบ',
            of: 'ที่',
            answerCorrect: 'เฉลย',
            title: 'หัวข้อ',
            matchTo: 'จับคู่กับ',
            seeAnswer: 'ดูเฉลย',

            canNotPublish: 'ไม่สามารถเผยแพร่คอร์สเรียนได้เนื่องจาก',

            successfullySave: 'บันทึกเรียบร้อย',
            canModifyLater: 'สามารถแก้ไขข้อมูลได้ภายหลัง',
            done: 'เสร็จสิ้น',

            deleteStudent: 'คุณต้องการลบผู้เรียนออกจากกลุ่มนี้หรือไม่',

            singleChoice: 'ตัวเลือกเดียว',
            fillGapText: 'เติมคำ',
            match: 'จับคู่',
            multiChoice: 'หลายตัวเลือก',

            courseInfoNotCompleted: 'กรุณากรอกข้อมูลคอร์สให้ครบถ้วน',
            createSuccess: 'สร้างคอร์สสำเร็จ',

            learner: 'ผู้เรียน',

            instructionPermissionMajor: '<strong class="font-weight-bold">คำแนะนำ </strong><strong class="font-weight-bold"><label class="headExplan">"</label>การกำหนดให้คณะ/สาขา<label class="headExplan">"</label></strong><br /> เข้าถึงคอร์สเรียนสามารถพิมพ์ชื่อกลุ่ม/คณะ/สาขา เพื่อค้นหา ',
            WhichMajorAccess: "คอร์สเรียนนี้สามารถเข้าถึง กลุ่ม/คณะ/สาขา ใดได้บ้าง",
            instructionPermissionOrganization: '<strong class="font-weight-bold">คำแนะนำ </strong><strong class="font-weight-bold"><label class="headExplan">"</label>การกำหนดกลุ่มให้กับองค์กร<label class="headExplan">"</label></strong><br />กดปุ่ม<strong class="font-weight-bold">เลือกกลุ่ม</strong> จะแสดงช่องค้นหาคณะ/สาขา<br />สามารถพิมพ์ชื่อกลุ่ม/คณะ/สาขา เพื่อค้นหา',
            organizationAccess: "องค์กรที่จะเข้าถึง",
            remove: "ลบ",
            chooseGroup: "เลือกกลุ่ม",
            addOrganization: "เพิ่มองค์กร",
            classroomGroup: "ห้องเรียน / กลุ่ม",
            back: "ย้อนกลับ",
            save: "บันทึก",
            close: "ปิด",
            ChooseGroupOrFaculty: "เลือกกลุ่ม/คณะ/สาขา",
            enterToSearch: "พิมพ์เพื่อค้นหา",
            userGroupRequired: "กรุณาระบุกลุ่มผู้ใช้",
            organizationLogo: "โลโก้บริษัท",
            organizationName: "ชื่อบริษัท",
            manageLearner: "จัดการผู้เรียน",
            all: "ทั้งหมด",
            add: "เพิ่ม",

            // Room
            addClassroom: "เพิ่มห้องเรียน/กลุ่ม",
            wantDelete: "คุณต้องการลบใช่หรือไม่?",
            addClassroomGroup: "เพิ่มกลุ่มห้องเรียน",
            classroomName: "ชื่อห้องเรียน/กลุ่ม",
            plsEnterGroupName: "กรุณากรอกชื่อกลุ่ม",
            tutorNameOfGroup: "ชื่ออาจารย์ประจำกลุ่ม",
            EnterTutorNameToSearch: "พิมพ์เพื่อค้นหาชื่ออาจารย์",
            permissionEditInformation: "สิทธิ์การแก้ไขข้อมูล",
            canEditCourse: "สามารถแก้ไขข้อมูลคอร์สเรียนได้",
            unableEditCourseInformation: "ไม่สามารถแก้ไขข้อมูลคอร์สเรียน",
            alertSuspendClassroomGroup: "คุณต้องการระงับกลุ่มห้องเรียนนี้หรือไม่?",
            alertEnableClassroomGroup: "คุณต้องการเปิดกลุ่มห้องเรียนนี้หรือไม่?",
            alertAfterSuspendClassroomGroup: "เมื่อระงับการใช้งานแล้ว คุณสามารถกลับมาเปิดการใช้งานได้อีกในภายหลัง",
            alertAfterEnableClassroomGroup: "หากยืนยัน จะเป็นการเปลี่ยนสถานะของกลุ่มห้องเรียนให้กลับมาใช้งานได้อีกครั้ง",
            savingFailed: "บันทึกไม่สำเร็จ",
            alertDuplicatedGroupName: "ชื่อกลุ่มนี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่นเพื่อสร้างกลุ่ม",
            lecturerName: "ชื่ออาจารย์",
            numberStudents: "จำนวนผู้เรียน",
            status: "สถานะ",
            editClassroomGroup: "แก้ไขกลุ่มห้องเรียน",

            manageLearners: {
                warningMsg1: 'บันทึกเรียบร้อย',
                warningMsg2: 'สามารถแก้ไขข้อมูลได้ภายหลัง',
                warningMsg3: 'คุณต้องการลบผู้เรียนออกจากคอร์สนี้หรือไม่',
                warningMsg4: 'คุณต้องการลบผู้เรียนที่เลือกออกจากคอร์สหรือไม่',
                warningMsg5: 'เมื่อลบแล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก',
                warningMsg6: 'ลบผู้เรียนเรียบร้อย',
                warningMsg7: 'ผู้เรียนถูกลบออกจากคอร์สเรียบร้อยแล้ว',
                warningMsg8: 'ยืนยันการส่งมอบใบรับรองให้กับผู้เรียนที่เลือก',
                warningMsg9: 'ส่งอีเมลให้กับผู้เรียนเรียบร้อย',
                warningMsg10: 'ส่งอีเมลให้กับผู้เรียนไม่สำเร็จ',
                warningMsg11: 'คุณต้องการลบผู้เรียนจากกลุ่มที่เลือกออกจากคอร์สหรือไม่',
                warningMsg12: 'ลบผู้เรียนไม่สำเร็จ',
                warningMsg13: 'มีบางอย่างผิดปกติ โปรดทำรายการใหม่อีกครั้ง',
                manage: 'จัดการผู้เรียน',
                importLearner: 'นำเข้าข้อมูลผู้เรียน',
                addLearner: 'เพิ่มผู้เรียน',
                addLearnerFromGroup: 'เพิ่มผู้เรียนจากกลุ่ม',
                requestJoinGroup: 'คำร้องขอเข้ากลุ่มเรียน',
                downloadSample: 'ดาวน์โหลดไฟล์ตัวอย่าง',

                profile: 'รูปโปรไฟล์',
                fullName: 'ชื่อ-นามสกุล',
                group: 'กลุ่ม',
                status: 'สถานะ',
                action: 'จัดการคำร้อง',

                groups: 'กลุ่ม',
                groupsLg: 'กลุ่ม',
                remove: 'ลบ',
                approve: 'อนุมัติ',
                confirmRemove: 'คุณต้องการลบผู้เรียนออกจากกลุ่มนี้หรือไม่',

                successRemove: 'ลบข้อมูลเรียบร้อย',
                successRemoveDetail: 'ข้อมูลได้ถูกลบออกจากระบบแล้ว ไม่สามารถนำข้อมูลกลับมาได้อีก',
                done: 'เสร็จสิ้น',

                importAvailable: 'สามารถนำเข้าได้',
                existed: 'มีห้องเรียนแล้ว',
                importFailed: 'นำเข้าไม่สำเร็จ',

                username: 'ชื่อผู้ใช้',
                firstName: 'ชื่อ',
                lastName: 'นามสกุล',
                email: 'อีเมล',

                remark: 'เหตุผล',

                cancel: 'ยกเลิก',
                confirmImport: 'ยืนยันการนำเข้าข้อมูล',

                searchStudent: 'ค้นหาผู้เรียน',
                searchStudentPlH: 'พิมพ์เพื่อค้นหา',
                noData: 'ไม่พบข้อมูล',
                close: 'ปิด',

                add: 'เพิ่ม',
                alreadyInCourse: 'อยู่คอร์สเรียนนี้แล้ว',
                notInCourse: 'ยังไม่ได้อยู่ในคอร์สเรียนนี้',

                chooseRoom: 'เลือกห้องเรียน',
                chooseRoomPlH: 'กรุณาเลือกห้องเรียน',
                addInstruction: 'หากกดปุ่ม "ยืนยันการนำเข้าข้อมูล" จะสามารถเพิ่มผู้เรียนที่ยังไม่ได้อยู่ในคอร์สเรียนนี้เท่านั้น',
                confirmAdding: 'ยืนยันการนำเข้าข้อมูล',

                specifyExpDate: 'กำหนดวันหมดอายุ',
                expType: 'รูปแบบวันหมดอายุ',
                selectExpDate: 'เลือกวันหมดอายุ',
                save: 'บันทึก',

                chooseDate: 'กำหนดเอง',
                lifeTime: 'ตลอดชีพ',
            }
        },

        liveStep: {
            searchLiveName: 'ค้นหาชื่อการถ่ายทอดสด',
            search: 'ค้นหา',
            liveStatusFilter: 'สถานะการถ่ายทอดสด',
            all: 'ทั้งหมด',
            waitLive: 'รอไลฟ์',
            live: 'กำลังไลฟ์',
            liveEnd: 'ไลฟ์จบ',
            reload: 'โหลดใหม่',
            addLive: 'เพิ่มการถ่ายทอดสด',

            liveName: 'ชื่อการถ่ายทอดสด',
            startDate: 'วันที่เริ่ม',
            endDate: 'วันที่จบ',
            liveStatus: 'สถานะ',
            action: 'การแก้ไข',

            onLive: 'กำลังถ่ายทอดสด',
            liveStarted: 'เริ่มการถ่ายทอดสด',
            liveEnded: 'สิ้นสุดการถ่ายทอด',

            delete: 'ลบ',

            addLiveDialog: {
                editAddLive: 'แก้ไข/เพิ่ม การถ่ายทอดสด',
                close: 'ปิดหน้าต่าง',
                detail: 'รายละเอียด',
                room: 'ห้องแชท',
                media: 'สื่อการสอน',
                question: 'คำถาม',
                startDate: 'วันที่เริ่ม',
                date: 'วันที่',
                cancel: 'ยกเลิก',
                ok: 'ตกลง',
                hh: 'ชั่วโมง',
                mm: 'นาที',
                endDate: 'วันที่จบ',
                save: 'บันทึก',
                failed: 'ไม่สำเร็จ',
                failedToEdit: 'แก้ไขข้อมูลไม่สำเร็จ',
                nameRules: 'กรุณาระบุชื่อ',
                descriptionRules: 'กรุณาระบุคำอธิบาย',

                url: 'URL',
                pdf: 'PDF',
                image: 'รูปภาพ',
                addContent: 'เพิ่มเนื้อหา',
                noData: 'ยังไม่มีข้อมูล',

                edit: 'แก้ไข',
                duplicate: 'Duplicate',
                delete: 'ลบ',

                addRoom: 'เพิ่มห้องแชท',

                addURL: 'เพิ่ม URL',
                urlName: 'ชื่อ URL',
                title: 'ชื่อ',

                titleRules: 'กรุณาระบุชื่อ',
                urlRules: 'กรุณาระบุ URL',

                addPDF: 'เพิ่ม PDF',
                fileTitle: 'ชื่อไฟล์',
                uploadFile: 'อัพโหลดไฟล์',
                chooseFile: 'เลือกไฟล์',
                sample: 'ตัวอย่างเอกสาร',

                addImage: 'เพิ่มรูปภาพ',
                uploadImage: 'อัพโหลดรูปภาพ',
                chooseImage: 'เลือกรูปภาพ',

                addQuestion: 'เพิ่มคำถาม',
                editAddQuestion: 'แก้ไข/เพิ่ม คำถาม',
                score: 'คะแนน',
                timer: 'การจับเวลา',
                minute: 'นาที',
                second: 'วินาที',

                answerType: 'ประเภทคำตอบ',
                answerText: 'แบบ Text',
                answerImage: 'แบบ รูปภาพ',

                uploadImageAswer: 'อัพโหลดรูปภาพ',
                remark: 'วิธีเลือกคำตอบที่ถูกคือคลิกที่ช่องวงกลมด้านซ้ายของคำตอบ',
                answer: 'คำตอบ',
                addAnswer: 'เพิ่มคำตอบ',
                deleteAnswer: 'ลบคำตอบ',

                confirmAnswerType: 'ยืนยันการเลือกรูปแบบตัวเลือก',
                msg1: 'รูปแบบของตัวเลือกสามารถกำหนดได้เพียง 1 รูปแบบเท่านั้น',
                msg2: 'หากกดปุ่มยืนยันแล้วจะเปลี่ยนรูปแบบตัวเลือกทันที',

                confirm: 'ยืนยัน',

                confirmDelete: 'คุณต้องการลบคำถามนี้หรือไม่',
                confirmDeleteInfo: 'เมื่อลบคำถามนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก',

                deleteSuccess: 'ลบคำถามเรียบร้อย',
                deleteSuccessInfo: 'คำถามถูกลบออกจากระบบเรียบร้อยแล้ว',
                done: 'เสร็จสิ้น',

                saveSuccess: 'บันทึกคำถามเรียบร้อย',
                saveSuccessInfo: 'คำถามได้ถูกบันทึกในระบบเรียบร้อยแล้ว',

                duplicateSuccess: 'บันทึกคำถามเรียบร้อย',
                duplicateSuccessInfo: 'คำถามได้ถูกบันทึกในระบบเรียบร้อยแล้ว',

                scoreRules: 'กรุณาระบุคะแนน',
                minuteRules: 'กรุณาระบุนาที',
                secondRules: 'กรุณาระบุวินาที',

            },
        },

        exam: {
            // exam
            examination: "ข้อสอบ",
            examination1: "ข้อสอบชุดที่ 1",
            examination2: "ข้อสอบชุดที่ 2",
            chooseExamination: "เลือกชุดข้อสอบ",
            examinationStatus: "สถานะการสอบ",
            score: "คะแนน",
            seeData: "ดูข้อมูล",
            all: "ทั้งหมด",
            neverDoExamination: "ยังไม่เคยสอบ",
            haveDoneExamination: "เคยสอบ",
            examinationRecord: "ประวัติการทำข้อสอบ",
            noExaminationRecord: "ยังไม่มีประวัติการสอบ",
            downloadexaminationRecord: "ดาวน์โหลดประวัติการสอบ",
            averageScore: "คะแนนเฉลี่ย",
            OverallExamScore: "กราฟแสดงคะแนนการสอบในแต่ละครั้ง",
            YaxisXaxis: "แกน Y: คะแนน / แกน X: ครั้งที่",
            startTime: "กรุณาระบุวันที่เริ่มต้น",
            endTime: "กรุณาระบุวันที่สิ้นสุด"
        },
        dialogChooseStudyingGroup: {
            groupName: "ชื่อกลุ่ม",
            lecturerName: "ชื่อครู",
            numberStudents: "จำนวนผู้เรียน",
            chooseGroup: "เลือกกลุ่ม",
        },
        stepCourse: {
            courseDetail: "รายละเอียดคอร์ส",
            lecture: "บทเรียน",
            bundle: "การขาย",
            live: "การถ่ายทอดสด",
            learnerManagement: "จัดการผู้เรียน",
        },
        close: "ปิด",
        success: "ความสำเร็จ",
        dialogAddFail: {
            unsuccessfulEditing: "แก้ไขคอร์สเรียนไม่สำเร็จ",
            errorEditing: "เกิดข้อผิดพลาดในการแก้ไขข้อมูล กรุณาลองใหม่อีกครั้ง",
        },
        live: {
            alertDeleteCantBringData: "เมื่อข้อมูลถูกลบออกจากระบบ จะไม่สามารถนำข้อมูลกลับมาได้อีก",
            alertDeletePdfCantBringData: "เมื่อ PDF ถูกลบออกจากระบบ จะไม่สามารถนำข้อมูลกลับมาได้อีก",
            alertDeleteRoomCantBringData: "เมื่อห้องแชทถูกลบออกจากระบบ จะไม่สามารถนำข้อมูลกลับมาได้อีก",
            alertDeleteUrlCantBringData: "เมื่อ URL ถูกลบออกจากระบบ จะไม่สามารถนำข้อมูลกลับมาได้อีก",
            alertDeleteImageCantBringData: "เมื่อรูปภาพถูกลบออกจากระบบ จะไม่สามารถนำข้อมูลกลับมาได้อีก",
        },

    },

    userGroupManagement: {
        add: 'เพิ่มกลุ่มย่อย',
        option: 'เพิ่มเติม',
        changeChild: 'เปลี่ยนกลุ่มย่อย',
        changeRoot: 'เปลี่ยนกลุ่มหลัก',
        chooseGroup: 'เลือกกลุ่ม',
        groupLevel1: 'กลุ่มหลักระดับที่ 1',
        groupLevel2: 'กลุ่มหลักระดับที่ 2',
        msg1: 'เลือกกลุ่มหลักใหม่',
        msg2: 'กำหนดให้กลุ่มนี้เป็นกลุ่มหลักใหม่',
        edit: 'แก้ไข',
        delete: 'ลบ',
        noGroup: "ยังไม่มีข้อมูล กรุณากดปุ่ม \"+ เพิ่มกลุ่มย่อย\"",
        course: 'คอร์ส',
        learner: 'ผู้เรียน',
        addGroup: 'เพิ่มกลุ่ม',
        editGroupName: 'แก้ไขชื่อกลุ่ม',
        editAddGroup: 'แก้ไข/เพิ่ม กลุ่ม',
        groupName: 'ชื่อกลุ่ม',
        groupNamePlH: 'กรุณากรอกชื่อกลุ่ม',
        groupNameRules: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        close: 'ปิด',
        confirm: 'ยืนยัน',
        deleteTitle: 'คุณต้องการลบกลุ่มนี้หรือไม่',
        deleteBody: 'หากทำการลบแล้วจะไม่สามารถนำข้อมูลกลับมาได้อีก',
        deleteAlert: 'ลบข้อมูลเรียบร้อย',
        deleteAlertBody: 'ข้อมูลได้ถูกลบออกจากระบบแล้ว ไม่สามารถนำข้อมูลกลับมาได้อีก',
        done: 'เสร็จสิ้น',
    },

    categoryManagement: {
        category: 'หมวดหมู่',
        search: 'ค้นหา',
        searchPlH: 'ค้นหาชื่อหมวดหมู่',
        status: 'สถานะ',
        all: 'ทั้งหมด',
        on: 'เปิด',
        off: 'ปิด',
        reload: 'โหลดใหม่',
        addCategory: 'เพิ่มหมวดหมู่',

        photo: 'รูปหมวดหมู่',
        name: 'ชื่อหมวดหมู่',
        createdDate: 'วันที่สร้าง',
        statusHeader: 'สถานะการใช้งาน',
        editCategory: 'แก้ไขหมวดหมู่',
        edit: 'แก้ไข',
        addEditCategory: 'เพิ่ม/แก้ไข หมวดหมู่',
        namePlH: 'กรุณากรอกชื่อหมวดหมู่',
        customizePhoto: 'แก้ไขรูปภาพ',
        photoRemark: '* คำแนะนำ: รูปภาพควรมีขนาด 1:1',
        uploadPhoto: 'อัปโหลดรูปภาพ',
        choosePhoto: 'เลือกรูปภาพ',
        chooseNewPhoto: 'เลือกรูปภาพใหม่',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        categoryNameRules: "กรุณากรอกชื่อหมวดหมู่",
        categoryNameRulesLimit: "ชื่อหมวดหมู่ต้องไม่มากกว่า 50 ตัวอักษร",

        confirmSuspend: 'คุณต้องการระงับหมวดหมู่นี้หรือไม่',
        suspendDetail: 'เมื่อระงับการใช้งานแล้ว สามารถกลับมาเปิดการใช้งานได้ภายหลัง',
        confirmActivate: 'คุณต้องการเปิดหมวดหมู่นี้หรือไม่',
        activateDetail: 'เป็นการเปลี่ยนสถานะหมวดหมู่ให้กลับมาใช้งานได้อีกครั้ง',

        successfullySave: 'บันทึกเรียบร้อย',
        canModifyLater: 'สามารถเปิด/ปิดการใช้งานได้ภายหลัง',
        done: 'เสร็จสิ้น',
        confirm: 'ยืนยัน',

        failedToSave: 'บันทึกไม่สำเร็จ',
        alertDuplicatedCategory: "ชื่อหมวดหมู่นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น",
        ok: 'ตกลง',

        failedToAdd: 'เพิ่มหมวดหมู่ไม่สำเร็จ',
        errorOccured: 'เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง',

        successfullyAdded: 'เพิ่มหมวดหมู่สำเร็จ',
        addingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

        successfullyEdited: 'แก้ไขหมวดหมู่สำเร็จ',
        editingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

        sorry: 'ขออภัย',
        msg1: 'คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ',
        msg2: 'กำหนดสิทธิ์',
        msg3: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',

        fileRules: 'กรุณาอัปโหลดไฟล์',
        fileRulesSize: 'ขนาดของไฟล์ต้องน้อยกว่า 20 MB',

        clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
        clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',

        moveToBin: 'ย้ายไปถังขยะ',
        confirmDeleteItem: 'คุณยืนยันที่จะลบรายการนี้หรือไม่ ?',
        recycleBin: 'กู้คืนหมวดหมู่',
        tooltripClose: "ปิด",
        recover: "กู้คืน",
    },

    skillManagement: {
        skill: 'ทักษะ',
        search: 'ค้นหา',
        searchPlH: 'ค้นหาชื่อทักษะ',
        status: 'สถานะ',
        all: 'ทั้งหมด',
        on: 'เปิด',
        off: 'ปิด',
        reload: 'โหลดใหม่',
        addSkill: 'เพิ่มทักษะ',

        name: 'ชื่อทักษะ',
        createdDate: 'วันที่สร้าง',
        statusHeader: 'สถานะการใช้งาน',
        editSkill: 'แก้ไขทักษะ',
        edit: 'แก้ไข',

        addEditSkill: 'เพิ่ม/แก้ไข ทักษะ',
        namePlH: 'กรุณากรอกชื่อทักษะ',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        skillNameRules: "กรุณากรอกชื่อทักษะ",
        skillNameRulesLimit: "ชื่อทักษะต้องไม่มากกว่า 50 ตัวอักษร",

        confirmSuspend: 'คุณต้องการระงับทักษะนี้หรือไม่',
        suspendDetail: 'เมื่อระงับการใช้งานแล้ว สามารถกลับมาเปิดการใช้งานได้ภายหลัง',
        confirmActivate: 'คุณต้องการเปิดทักษะนี้หรือไม่',
        activateDetail: 'เป็นการเปลี่ยนสถานะทักษะให้กลับมาใช้งานได้อีกครั้ง',

        successfullySave: 'บันทึกเรียบร้อย',
        canModifyLater: 'สามารถเปิด/ปิดการใช้งานได้ภายหลัง',
        done: 'เสร็จสิ้น',
        confirm: 'ยืนยัน',

        failedToSave: 'บันทึกไม่สำเร็จ',
        alertDuplicatedSkill: "ชื่อทักษะนี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น",
        ok: 'ตกลง',

        failedToAdd: 'เพิ่มทักษะไม่สำเร็จ',
        errorOccured: 'เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง',

        successfullyAdded: 'เพิ่มทักษะสำเร็จ',
        addingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

        successfullyEdited: 'แก้ไขทักษะสำเร็จ',
        editingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

        sorry: 'ขออภัย',
        msg1: 'คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ',
        msg2: 'กำหนดสิทธิ์',
        msg3: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',

        fileRules: 'กรุณาอัปโหลดไฟล์',
        fileRulesSize: 'ขนาดของไฟล์ต้องน้อยกว่า 20 MB',

        clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
        clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',

        moveToBin: 'ย้ายไปถังขยะ',
        confirmDeleteItem: 'คุณยืนยันที่จะลบรายการนี้หรือไม่ ?',
        recycleBin: 'กู้คืนทักษะ',
        tooltripClose: "ปิด",
        recover: "กู้คืน",
    },

    gradeManagement: {
        level: 'ระดับ',
        search: 'ค้นหา',
        searchPlH: 'ค้นหาชื่อระดับ',
        status: 'สถานะ',
        all: 'ทั้งหมด',
        on: 'เปิด',
        off: 'ปิด',
        reload: 'โหลดใหม่',
        addGrade: 'เพิ่มระดับ',

        photo: 'รูประดับ',
        name: 'ชื่อระดับ',
        createdDate: 'วันที่สร้าง',
        statusHeader: 'สถานะการใช้งาน',
        editGrade: 'แก้ไขระดับ',
        edit: 'แก้ไข',
        addEditGrade: 'เพิ่ม/แก้ไข ระดับ',
        namePlH: 'กรุณากรอกชื่อระดับ',
        customizePhoto: 'แก้ไขรูปภาพ',
        photoRemark: '* คำแนะนำ: รูปภาพควรมีขนาด 16:9',
        uploadPhoto: 'อัปโหลดรูปภาพ',
        choosePhoto: 'เลือกรูปภาพ',
        chooseNewPhoto: 'เลือกรูปภาพใหม่',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        gradeNameRules: "กรุณากรอกชื่อระดับ",
        gradeNameRulesLimit: "ชื่อระดับต้องไม่มากกว่า 50 ตัวอักษร",

        confirmSuspend: 'คุณต้องการระงับระดับนี้หรือไม่',
        suspendDetail: 'เมื่อระงับการใช้งานแล้ว สามารถกลับมาเปิดการใช้งานได้ภายหลัง',
        confirmActivate: 'คุณต้องการเปิดระดับนี้หรือไม่',
        activateDetail: 'เป็นการเปลี่ยนสถานะระดับให้กลับมาใช้งานได้อีกครั้ง',

        successfullySave: 'บันทึกเรียบร้อย',
        canModifyLater: 'สามารถเปิด/ปิดการใช้งานได้ภายหลัง',
        done: 'เสร็จสิ้น',
        confirm: 'ยืนยัน',

        failedToSave: 'บันทึกไม่สำเร็จ',
        alertDuplicatedGrade: "ระดับนี้มีในระบบแล้ว กรุณาใช้ชื่ออื่น",
        ok: 'ตกลง',

        failedToAdd: 'เพิ่มระดับไม่สำเร็จ',
        errorOccured: 'เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง',

        successfullyAdded: 'เพิ่มระดับสำเร็จ',
        addingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

        successfullyEdited: 'แก้ไขระดับสำเร็จ',
        editingIsDone: 'เราได้บันทึกข้อมูลของคุณแล้ว',

        sorry: 'ขออภัย',
        msg1: 'คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ',
        msg2: 'กำหนดสิทธิ์',
        msg3: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',

        fileRules: 'กรุณาอัปโหลดไฟล์',
        fileRulesSize: 'ขนาดของไฟล์ต้องน้อยกว่า 20 MB',

        clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
        clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',

        moveToBin: 'ย้ายไปถังขยะ',
        confirmDeleteItem: 'คุณยืนยันที่จะลบรายการนี้หรือไม่ ?',
        recycleBin: 'กู้คืนระดับ',
        tooltripClose: "ปิด",
        recover: "กู้คืน",
    },

    bannerManagement: {
        banner: 'โฆษณา',
        search: 'ค้นหา',
        searchPlH: 'ค้นหาชื่อโฆษณา',
        status: 'สถานะ',
        all: 'ทั้งหมด',
        on: 'เปิด',
        off: 'ปิด',
        reload: 'โหลดใหม่',
        addBanner: 'เพิ่มโฆษณา',
        clickToSuspend: 'คลิกเพื่อระงับการใช้งาน',
        clickToActivate: 'คลิกเพื่อเปิดการใช้งาน',
        edit: 'แก้ไข',
        addEditBanner: 'เพิ่ม/แก้ไข โฆษณา',
        name: 'ชื่อโฆษณา',
        namePlH: 'กรุณากรกชื่อโฆษณา',
        url: 'ลิงก์',
        urlPlH: 'กรุณากรกลิงก์',
        customizePhoto: 'แก้ไขรูปภาพ',
        photoRemark: '* คำแนะนำ: รูปภาพควรมีขนาด 16:9',
        uploadPhoto: 'อัปโหลดรูปภาพ',
        choosePhoto: 'เลือกรูปภาพ',
        chooseNewPhoto: 'เลือกรูปภาพใหม่',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        fileRules: 'กรุณาอัปโหลดไฟล์',
        fileRulesSize: 'ขนาดของไฟล์ต้องน้อยกว่า 20 MB',
        bannerNameRules: "กรุณากรอกชื่อโฆษณา",
        bannerNameRulesLimit: "ชื่อโฆษณาต้องไม่มากกว่า 100 ตัวอักษร",
        photo: 'รูปโฆษณา',
        createdDate: 'วันที่สร้าง',
        statusHeader: 'สถานะการใช้งาน',
        editBanner: 'แก้ไขโฆษณา',
        action: 'จัดการโฆษณา',
        delete: 'ลบ',
        moveToBin: 'ย้ายไปถังขยะ',
        confirmUnpublish: 'คุณต้องการระงับการเผยแพร่โฆษณานี้หรือไม่ ?',
        unpublishDescript: 'เมื่อระงับการใช้งานแล้ว คุณสามารถกลับมาเผยแพร่ใหม่ได้ภายหลัง',
        confirmPublish: 'คุณต้องการเปิดการเผยแพร่โฆษณานี้หรือไม่?',
        publishDescript: 'เป็นการเปลี่ยนสถานะโฆษณาให้กลับมาเผยแพร่อีกครั้ง',
        successfullySave: 'บันทึกเรียบร้อย',
        canModifyLater: 'สามารถเปิด/ปิดการใช้งานได้ภายหลัง',
        done: 'เสร็จสิ้น',
        confirmDeleteItem: 'คุณยืนยันที่จะลบรายการนี้หรือไม่ ?',
        bannerOrdering: 'แก้ไขลำดับโฆษณา',
        tooltripClose: 'ปิดหน้าต่าง',
        dragToMoveSequence: 'ลากเพื่อย้ายลำดับ',
        recycleBin: 'กู้คืนโฆษณา',
        recover: 'กู้คืน',

    },

    dontHavePermisisonLong: 'คุณไม่สามารถเข้าถึงรายการนี้ได้ เนื่องจากไม่มีการกำหนดสิทธิ์ การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',
    dontHavePermisison: 'คุณไม่สามารถเข้าถึงรายการนี้ได้ เนื่องจากไม่มีการ',
    permission: 'กำหนดสิทธิ์',
    reachAccount: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',
    registerTeacher: 'สมัครเป็นครู เพื่อเข้าถึงรายการนี้',
    // requestTeacher: 'สมัครเป็นครู เพื่อเข้าถึงรายการนี้',
    requestTeacherAgain: 'กรุณา<strong>&nbsp;สมัครเป็นครู&nbsp;</strong> ใหม่อีกครั้งเพื่อสามรถเข้าถึงรายการนี้',
    courseName: 'ชื่อคอร์สเรียน',
    courseNameTh: 'ชื่อคอร์สเรียนภาษาไทย',
    courseNameEng: 'ชื่อคอร์สเรียนภาษาอังกฤษ',
    courseDescription: 'คำอธิบายคอร์สเรียน',
    courseNameRule: 'กรุณากรอกชื่อคอร์ส',
    courseNameEngRule: 'กรุณากรอกชื่อคอร์สภาษาอังกฤษ',
    level: 'ระดับ',
    category: 'หมวดหมู่',
    trade: 'การซื้อขาย',
    duration: 'ประเภทวันหมดอายุ',
    pricing: 'ราคา',
    day: 'จำนวนวัน',
    date: 'กำหนดวันที่',
    skill: 'ทักษะ',
    chooseLevel: 'เลือกระดับ',
    chooseCategory: 'เลือกหมวดหมู่',
    choosePurchasing: 'เลือกการซื้อขาย',
    chooseDuration: 'เลือกประเภทวันหมดอายุ',
    choosePrice: 'กรุณากรอกราคา',
    typeDay: 'กรุณากรอกจำนวนวัน',
    chooseSkill: 'เลือกทักษะ',
    studyingType: 'วิธีการเรียน',
    setOwner: 'กำหนดเจ้าของคอร์ส',
    myself: 'ตนเอง',
    chooseInstructor: 'กรุณาเลือกผู้สอน',
    otherInstructor: 'ผู้อื่น',
    independentStudy: 'เรียนแบบอิสระ',
    sequentlyStudy: 'เรียนตามลำดับบทเรียน',
    discussionBoard: 'บอร์ดแลกเปลี่ยนความคิดเห็น',
    enable: 'มี',
    disable: 'ไม่มี',
    sendDirect: 'ส่งข้อความโดยตรงถึงผู้สอน',
    courseCover: 'ภาพปกของคอร์ส',
    chooseCourseCover: 'เลือกรูปภาพปกของคอร์ส',
    certificatesOption: 'ตัวเลือกการมอบใบรับรอง',
    noCertificate: 'ไม่มอบใบรับรอง',
    yesCertificate: 'มอบใบรับรอง',
    certificatesTemplate: 'เทมเพลตใบรับรอง',
    settingTop: 'ระยะด้านบน',
    settingLeft: 'ระยะด้านซ้าย',
    setPercent: 'กำหนดเกณฑ์การได้รับ',

    infoToMyCourse: 'หากต้องการกลับหน้าคอร์สของฉัน กดปุ่ม',
    infoCourseList: 'รายการคอร์ส',
    infoCreateCourse: 'หากต้องการสร้างบทเรียน กดปุ่ม ',
    orOnTap: 'หรือกดแถบ ',
    infoLecture: 'บทเรียน',
    top: 'ด้านบน',

    create: ' สร้างคอร์ส',
    btnCourseList: 'รายการคอร์ส',
    // live
    liveName: 'ชื่อการถ่ายทอดสด',
    liveDescription: 'คำอธิบายการถ่ายทอดสด',
    Date: 'วันที่',
    StartTime: 'เวลาที่เริ่ม',
    EndTime: 'เวลาที่สิ้นสุด',
    liveType: 'ประเภทของการถ่ายทอดสด',
    liveTypebyMyself: 'ถ่ายทอดสดด้วยตัวเอง',
    liveTypebyVideo: 'ถ่ายทอดสดด้วยวิดีโอที่เตรียมไว้',

    // Alert
    plsUploadPhoto: "กรุณาอัปโหลดรูปภาพ",
    plsChooseCategory: "กรุณาเลือกหมวดหมู่",
    plsChooseTrade: "กรุณาเลือกการซื้อขาย",
    plsChooseDurationType: "กรุณาเลือกประเภทวันหมดอายุ",
    plsChooseSkill: "กรุณาเลือกทักษะ",
    plsChooseUnder20MB: "กรุณาเลือกรูปภาพที่ขนาดไม่เกิน 20 MB",
    plsEnterAllData: "กรุณากรอกข้อมูลให้ครบถ้วน",
    plsChooseFile: "กรุณาเลือกไฟล์",
    plsChooseLevel: "กรุณาเลือกระดับ",

    averageScore: "คะแนนเฉลี่ย",
    No: "ครั้งที่",
    // profile
    profilePic: "รูปโปรไฟล์",
    fullName: "ชื่อ-สกุล",
    progress: "ความคืบหน้า",
    email: "อีเมล",
    username: "ชื่อผู้ใช้",
    classroom: "ห้องเรียน",
    report: "รายงาน",
    studentInformation: "ข้อมูลผู้เรียน",

    companyManagement: {
        updateSuccess: 'บันทึกข้อมูลเรียบร้อย',
        updateInfoSuccess: "ข้อมูลขององค์กรได้ถูกบันทึกในระบบเรียบร้อยแล้ว"
    },
    company: {
        companyDetail: 'รายละเอียดองค์กร',
        companyName: 'ชื่อองค์กร',
        description: 'คำอธิบาย',
        contactEmail: 'อีเมลสำหรับติดต่อกับองค์กร',
        systemEmail: 'ชื่อผู้ใช้งาน/อีเมล',
        msg1: 'ใช้สำหรับล็อกอิน',
        subDomain: 'ชื่อโดเมน',
        externalAccess: 'การเข้าถึงจากภายนอก',
        externalAccessNo: 'ไม่อนุญาต',
        externalAccessYes: 'อนุญาต',
        msg2: 'บุคคลนอกองค์กรไม่สามารถเข้าถึงได้',
        msg3: 'บุคคลนอกองค์กรสามารถเข้าถึงได้',
        Limitation: 'การจำกัดการใช้งาน',
        allowRegister: 'การอนุญาตให้ลงทะเบียนผู้ใช้',
        allowRegisterNo: 'ไม่อนุญาต',
        allowRegisterYes: 'อนุญาต',
        msg4: 'ผู้ใช้ไม่สามารถลงทะเบียนด้วยตนเองได้',
        msg5: 'ผู้ใช้สามารถลงทะเบียนด้วยตนเองได้',
        registerOption: 'ตัวเลือกการลงทะเบียน',
        registerOptionEmail: 'อีเมล',
        registerOptionFacebook: 'เฟซบุ๊ก',
        registerOptionGmail: 'จีเมล',
        customizePhoto: 'ปรับแต่งรูปภาพ',
        landscapeImage: 'ภาพโลโก้แนวนอน',
        squareImage: 'ภาพโลโก้สี่เหลี่ยมจตุรัส',
        chooseFile: 'เลือกไฟล์',
        msg6: 'รูปแบบที่ยอมรับ .png .jpg ',
        msg7: 'ขนาดไฟล์สูงสุดคือ 3MB',
        errorTitleFileTooLarge: 'พบข้อผิดพลาด',
        errorMsgFileTooLarge: 'ไฟล์มีขนาดเกิน 3MB กรุณาลดขนาดไฟล์และลองใหม่อีกครั้ง',
        errorTitleFileNotImage: 'พบข้อผิดพลาด',
        errorMsgFileNotImage: 'ไฟล์ไม่ได้อยู่ในรูปแบบ .jpg หรือ .png กรุณาเลือกไฟล์ใหม่อีกครั้ง',
        customizeColor: 'ปรับแต่งสี',
        themeColor: 'สีธีม',
        headerColor: 'สี Header',
        footerColor: 'สี Footer',
        buttonColor: 'สีปุ่ม',
        preview: 'ตัวอย่าง',
        seemore: 'ดูเพิ่มเติม',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        done: 'เสร็จสิ้น',
        ok: 'ตกลง',
        confirm: 'ยืนยัน',
        saveFailed: 'บันทึกไม่สำเร็จ',
        msg8: 'โดเมนนี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น',
        msg9: 'กรุณากรอกข้อมูลให้ครบถ้วน',

        companyTabbar: 'แถบเมนู',
        info1: 'แถบเมนูจะปรากฏที่ด้านล่างของหน้าจอแอปและช่วยให้ผู้คนสลับไปมาระหว่างส่วนต่าง ๆ ของแอปได้อย่างรวดเร็วแถบเมนูอาจโปร่งแสง หรือมีสีพื้นหลังแถบเมนูอาจมีจํานวนเท่าใดก็ได้ แต่จํานวนของเมนูที่มองเห็นได้จะแตกต่างกันไปตามขนาดและการวางแนวของอุปกรณ์ ถ้าไม่สามารถแสดงบางแท็บได้เนื่องจากพื้นที่ที่จํากัด',
        menuList: 'รายการเมนู',
        delete: 'ลบ',
        hover1: 'คลิกเพื่อแก้ไข หรือลากเพื่อจัดลำดับ',
        addMenu: 'เพิ่มเมนู',
        newMenu: 'เมนูใหม่',
        menuName: 'ชื่อเมนู',
        templateType: 'เทมเพลตเมนู',
        elementList: 'องค์ประกอบเนื้อหา',
        info2: 'องค์ประกอบสามารถจัดการชุดเนื้อหาตามลำดับเช่น แถบโฆษณา อีกทั้งยังสามารถปรับแต่งได้เนื่องจากองค์ประกอบของเนื้หาไม่บังคับใช้รูปแบบเชิงเส้นอย่างเคร่งครัดจึงเหมาะอย่างยิ่งกับการแสดงรายการที่มีขนาดแตกต่างกันไป',
        hover2: 'ลากเพื่อจัดลำดับ',
        addElement: 'เพิ่มองค์ประกอบเนื้อหา',
        add: 'เพิ่ม',
        contentTemplate: 'เทมเพลตเนื้อหา',
        elementTitle: 'ชื่อองค์ประกอบ',
        elementDescription: 'คำอธิบายองค์ประกอบ',
        ContentSetting: 'ตั้งค่าเนื้อหา',
        orderBy: 'เรียงตาม',
        displayItemLimit: 'จำนวนที่ต้องการแสดงสูงสุด',
        mobile: 'แสดงบนมือถือ',
        tablet: 'แสดงบนแท็บเล็ต',
        desktop: 'แสดงบนเว็บไซต์',
        msg10: 'คุณต้องการลบหรือไม่',
        msg11: 'หากคุณลบองค์ประกอบคุณจะไม่สามารถแสดงได้อีก',
        msg12: 'คุณต้องการลบแถบเมนูนี้หรือไม่',
        msg13: 'หากคุณลบแถบเมนูนี้ แถบเมนูนี้จะไม่แสดงบนแอปพลิเคชันของคุณ',
        msg14: 'การตั้งค่าเมนูไม่สมบูรณ์',
        msg15: 'บันทึกสำเร็จ',
        msg16: 'เมนูได้ถูกบันทึกแล้ว',
        msg17: 'องค์ประกอบเนื้อหาได้ถูกบันทึกแล้ว',
        msg18: 'กรุณาเลือกเทมเพลต',
        msg19: 'ชื่อองค์ประกอบ',
        msg20: 'คำอธิบายองค์ประกอบ',
        msg21: 'เลือกการเรียงตาม',

    },


}